export const GENERATED = [
    {
        "id": "mini-gen-0003",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In addition; as well",
                "answer": "ALSO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Big stadium where games are played",
                "answer": "ARENA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Genuine and real, in casual speech",
                "answer": "LEGIT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Chairs in a theater or on a bus",
                "answer": "SEATS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Just this and nothing more",
                "answer": "ONLY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Color of grass and spring leaves",
                "answer": "GREEN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sticky stuff that holds paper together",
                "answer": "GLUE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Allowed by the law",
                "answer": "LEGAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Togetherness; being as one",
                "answer": "UNITY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Has a meal; munches",
                "answer": "EATS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0005",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of; in favor of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Big to-do over something small",
                "answer": "FUSS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single time; just one occasion",
                "answer": "ONCE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Unruly, noisy public disturbances",
                "answer": "RIOTS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Separate pieces or apartments in a building",
                "answer": "UNITS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Honest and accurate; not false",
                "answer": "TRUE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Ninth month, on a calendar abbreviation",
                "answer": "SEPT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The points each team has in a game",
                "answer": "SCORE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Get something ready to use",
                "answer": "SETUP",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"Ready, ___, go!\"",
                "answer": "SET",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0007",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put the table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Goods sold at a shop; a store's earnings",
                "answer": "SALES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Numbers like two, four, and six",
                "answer": "EVEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A quiz or exam at school",
                "answer": "TEST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Serious and solemn, as a tone of voice",
                "answer": "GRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Color of storm clouds, spelled the British way",
                "answer": "GREY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Wander or roam freely",
                "answer": "ROVE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Parts that actors play on stage",
                "answer": "ROLES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A happening, like a party or concert",
                "answer": "EVENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Agreeable answer, the opposite of no",
                "answer": "YES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0008",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not brand new; already broken in",
                "answer": "USED",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put something to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "\"Thou ___ not\"; an old-fashioned must",
                "answer": "SHALL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Spooky and strange, as an old house at night",
                "answer": "EERIE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Days marked on the calendar",
                "answer": "DATES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Tree whose nut butter soothes the skin",
                "answer": "SHEA",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The planet we all live on",
                "answer": "EARTH",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Small simple shelter or cabin",
                "answer": "HUT",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "In place of; instead, in the old phrase \"in ___ of\"",
                "answer": "LIEU",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "For fear that; in case",
                "answer": "LEST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0009",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Roughly; approximately",
                "answer": "ABOUT",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Book of maps for travelers",
                "answer": "ATLAS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The thinking organ inside your head",
                "answer": "BRAIN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Beat a rival; do better than",
                "answer": "OUTDO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Speak aloud; pronounce a word",
                "answer": "UTTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Word pointing at this group right here",
                "answer": "THESE",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Honesty; the way things really are",
                "answer": "TRUTH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Coffee with steamed milk, Italian style",
                "answer": "LATTE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Helpers and assistants to a leader",
                "answer": "AIDES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Heavy breathing sound made while fast asleep",
                "answer": "SNORE",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0010",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "At what time?",
                "answer": "WHEN",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Tiny brown garden bird with a perky tail",
                "answer": "WREN",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put under a magic spell",
                "answer": "HEXED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Doorway into a building; a written record",
                "answer": "ENTRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Boldness, or the cord that carries feeling to the body",
                "answer": "NERVE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Sign up again; make fresh once more",
                "answer": "RENEW",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Methods or paths to get somewhere",
                "answer": "WAYS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Additional; more than the usual amount",
                "answer": "EXTRA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Bold and a bit cheeky in manner",
                "answer": "NERVY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Colors cloth by soaking it",
                "answer": "DYES",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0011",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Pointing word: \"this or ___\"",
                "answer": "THAT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Buying and selling between businesses",
                "answer": "TRADE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Great destruction and chaos",
                "answer": "HAVOC",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Turn aside to prevent; head off a problem",
                "answer": "AVERT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The pitch or sound of a voice",
                "answer": "TONE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Cheer of approval, often shouted at the opera",
                "answer": "BRAVO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Undergarments worn on top",
                "answer": "BRAS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Glossy black bird that croaks",
                "answer": "RAVEN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Love dearly; cherish",
                "answer": "ADORE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A particular group or faction",
                "answer": "SECT",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0012",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Time ___,\" called by an umpire",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Green spot with water in the desert",
                "answer": "OASIS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single thing; one of a set",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Number after nine",
                "answer": "TEN",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The flowing hair on a horse's neck",
                "answer": "MANE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Short note to remind yourself",
                "answer": "MEMO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Sticky tree sap used in varnish",
                "answer": "RESIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Tennis term for a tie score",
                "answer": "RES",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Give off, as light or smoke",
                "answer": "EMIT",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Distress call sent by a sinking ship",
                "answer": "SOS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0013",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take action; perform on stage",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Capable; skilled enough to do something",
                "answer": "ABLE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A family group, especially in Scotland",
                "answer": "CLAN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Comes right after ninth",
                "answer": "TENTH",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Gloomy and bare, like a windswept moor",
                "answer": "BLEAK",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A plot of land, about a football field in size",
                "answer": "ACRE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Things that open locks",
                "answer": "KEYS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Long spear once used by knights",
                "answer": "LANCE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Doorway, or the act of coming in",
                "answer": "ENTRY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"Hers and ___\"; belonging to him",
                "answer": "HES",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0014",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Z",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Notice with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Device that finds objects underwater using sound",
                "answer": "SONAR",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A line written in a diary or ledger",
                "answer": "ENTRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Ghostly and unsettling",
                "answer": "EERIE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Separate areas marked off for a purpose",
                "answer": "ZONES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Fastener that opens and closes a coat",
                "answer": "ZIP",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Ship's plea for help, in three letters",
                "answer": "SOS",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Opening section of a song or book",
                "answer": "INTRO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Capital city of France",
                "answer": "PARIS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Grain used to make whiskey and dark bread",
                "answer": "RYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0015",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However; on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Metal pins that screw onto nuts",
                "answer": "BOLTS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single thing in a series",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sort or kind, as of music",
                "answer": "TYPE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Showy garden flower, often deep pink or red",
                "answer": "PEONY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Tall flag stand, or the North or South point of Earth",
                "answer": "POLE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A big test at the end of a course",
                "answer": "EXAM",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Spring wildflower of the primrose family",
                "answer": "OXLIP",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Frothy coffee served in cafes",
                "answer": "LATTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Paramedics, for short",
                "answer": "EMS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0016",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Slippery cooking liquids, or what wells pump up",
                "answer": "OILS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word an umpire shouts at the plate",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Lifeless and dull; without energy",
                "answer": "INERT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Big ocean ship that carries passengers",
                "answer": "LINER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Took quietly without permission",
                "answer": "STOLE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single thing, complete in itself",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Deep singing voice between bass and alto",
                "answer": "TENOR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Grain that flavors a deli bread",
                "answer": "RYE",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Count on; depend upon",
                "answer": "RELY",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Tall plant with a trunk and branches",
                "answer": "TREE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0017",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "These ones' counterparts farther away",
                "answer": "THOSE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Swap one thing for another; commerce",
                "answer": "TRADE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Spiral shape, like a winding staircase or DNA",
                "answer": "HELIX",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small green or black fruit pressed for oil",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Curved sword, or a fencer's blade",
                "answer": "SABER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Be real; have being",
                "answer": "EXIST",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Unwind and take it easy",
                "answer": "RELAX",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Proof of being elsewhere when something happened",
                "answer": "ALIBI",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Plunges headfirst into the water",
                "answer": "DIVES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put forth effort; apply, as force",
                "answer": "EXERT",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0018",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The greatest amount",
                "answer": "MOST",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wound or cripple",
                "answer": "MAIM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The person who possesses something",
                "answer": "OWNER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Spanish word for a saint, seen in city names",
                "answer": "SANTO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Levels or ranks, one above another",
                "answer": "TIERS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Hold off and stay patient until something comes",
                "answer": "AWAIT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Ancient city of the famous wooden horse",
                "answer": "TROY",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Closer to the center; deep within",
                "answer": "INNER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "City train that runs underground",
                "answer": "METRO",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Cheerful and pink-cheeked",
                "answer": "ROSY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0019",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The two of them together",
                "answer": "BOTH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wash yourself in the tub",
                "answer": "BATHE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Frequently; many a time",
                "answer": "OFTEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rows of seats rising one behind another",
                "answer": "TIERS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Damage or injury",
                "answer": "HARM",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Secret criminal gang of old Sicily",
                "answer": "MAFIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Winged insect drawn to a porch light",
                "answer": "MOTH",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Furry animal that floats on its back and cracks shells",
                "answer": "OTTER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Word part meaning heat, as in a flask that keeps drinks warm",
                "answer": "THERM",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Mother chickens",
                "answer": "HENS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0020",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In support of; not against",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Repairs; sets right what was broken",
                "answer": "FIXES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Was in debt for a certain amount",
                "answer": "OWED",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Took away; got the place clear of",
                "answer": "RID",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Small fuzzy green fruit from New Zealand",
                "answer": "KIWI",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The bottom ridge running along a boat's hull",
                "answer": "KEEL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Determined the gender of, as a chick",
                "answer": "SEXED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Carbonated drink suffix, or a Buddhist branch",
                "answer": "SHA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Paid close attention to a warning",
                "answer": "HEED",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "More than one Al, casually",
                "answer": "ALS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0021",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word meaning \"in place of\" in a trade",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "College brotherhood, for short",
                "answer": "FRAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Solemn promise sworn aloud",
                "answer": "OATH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Formal ceremonies and customs",
                "answer": "RITES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bars or fences that keep you from falling",
                "answer": "RAILS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Low in calories, on a food label",
                "answer": "LITE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Read a page quickly; sweep with the eyes",
                "answer": "SCAN",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Storage space up under the roof",
                "answer": "ATTIC",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Greek letter that looks like a circle with a line",
                "answer": "THETA",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Member of a lawmaking body, for short",
                "answer": "SEN",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0023",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Place the table for supper",
                "answer": "SET",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The dirt and earth where plants grow",
                "answer": "SOILS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The cutting border of a knife",
                "answer": "EDGE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Canvas shelter used while camping",
                "answer": "TENT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A home; a place where one lives",
                "answer": "ABODE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A solo song in an opera",
                "answer": "ARIA",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Curve around a corner",
                "answer": "BEND",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Rule over as a king or queen",
                "answer": "REIGN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Narrow bay where the sea reaches the land",
                "answer": "INLET",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Notices in the newspaper selling things, for short",
                "answer": "ADS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0024",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Second-hand; not fresh from the shop",
                "answer": "USED",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Make practical of a tool",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Found out the gender of, as chicks",
                "answer": "SEXED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Gritty board for filing the fingernails",
                "answer": "EMERY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Slow, sad tune played at a funeral",
                "answer": "DIRGE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Half of something, as in a truck cab",
                "answer": "SEMI",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Apply steady force; strain to do",
                "answer": "EXERT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A rocky hill on the moor",
                "answer": "TOR",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Therefore; as a result",
                "answer": "ERGO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "One who colors fabric for a living",
                "answer": "DYER",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0026",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The opposite of up",
                "answer": "DOWN",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Beloved, or how a letter often begins",
                "answer": "DEAR",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Path a planet travels around the sun",
                "answer": "ORBIT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Put words on paper with a pen",
                "answer": "WRITE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Points where lines meet, or spots on a network",
                "answer": "NODES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A mistake or slip-up",
                "answer": "ERROR",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Take a break and put your feet up",
                "answer": "REST",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Put up with; remain faithful to a rule",
                "answer": "ABIDE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Ceremonies, like those at a wedding",
                "answer": "RITES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A trial run to check how something works",
                "answer": "TEST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0027",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "At what moment in time?",
                "answer": "WHEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In which place?",
                "answer": "WHERE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Gaps or openings, as in a worn sock",
                "answer": "HOLES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Put a law into effect; pass it",
                "answer": "ENACT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Coming right after this one",
                "answer": "NEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Handheld device for making calls",
                "answer": "PHONE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Get ready ahead of time",
                "answer": "PREP",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Loosen up and rest",
                "answer": "RELAX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Stand up straight and tall",
                "answer": "ERECT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "An annoying little nuisance, like a fly",
                "answer": "PEST",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0028",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word meaning \"in favor of\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Companies or businesses",
                "answer": "FIRMS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Solely; just this much",
                "answer": "ONLY",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Cleared away; got the room free of clutter",
                "answer": "RID",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Very small, like a tiny skirt or car",
                "answer": "MINI",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A greater amount; not less",
                "answer": "MORE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The whole earth and everyone on it",
                "answer": "WORLD",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A path or method of doing something",
                "answer": "WAY",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The nation's soldiers",
                "answer": "ARMY",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Word of agreement; a nod of approval",
                "answer": "YES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0029",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In place of, in a swap",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Slowly grow faint and disappear",
                "answer": "FADE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Above; finished, as a game",
                "answer": "OVER",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Parts actors take on in a play",
                "answer": "ROLES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Steer clear of; keep away from",
                "answer": "AVOID",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Scratchy feeling that begs for a good rub",
                "answer": "ITCH",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A day marked on the calendar; also a sweet fruit",
                "answer": "DATE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Fourth Greek letter, shaped like a triangle",
                "answer": "DELTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Build standing upright",
                "answer": "ERECT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The lady; a female being spoken of",
                "answer": "SHE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0030",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch sight of",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "What good eyes give you; a lovely view",
                "answer": "SIGHT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A blunder or slip-up",
                "answer": "ERROR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rough board for smoothing the nails",
                "answer": "EMERY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Solid companies, or steady handshakes' quality",
                "answer": "FIRMS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Plump; the opposite of thin",
                "answer": "FAT",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Lawmaker in Washington, for short",
                "answer": "SEN",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Say yes; be of the same mind",
                "answer": "AGREE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sharp prickle on a rose stem",
                "answer": "THORN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Give it a go; make an attempt",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0031",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This gift is ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put paperwork away in a folder, in past tense",
                "answer": "FILED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Not shut",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A nice sit-down after a long day",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Complain or grumble about something",
                "answer": "GRIPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Got taller, as a child did",
                "answer": "GREW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Wander about with no set path",
                "answer": "ROVE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Parts that actors play in a show",
                "answer": "ROLES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A wedding or a concert, for instance",
                "answer": "EVENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Got married, for short",
                "answer": "WED",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0032",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not brand new; previously owned",
                "answer": "USED",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put a tool to work",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Old-fashioned \"shall,\" as in the Commandments",
                "answer": "SHALT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Strange and a little spooky",
                "answer": "EERIE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sweet, sticky fruits often packed in boxes",
                "answer": "DATES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "___ butter, a skin-softening lotion ingredient",
                "answer": "SHEA",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The planet we all live on",
                "answer": "EARTH",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A small simple shelter, like a beach cabin",
                "answer": "HUT",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "In place of; \"in ___ of\"",
                "answer": "LIEU",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A quiz or an exam at school",
                "answer": "TEST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0033",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Texas or Ohio, for example",
                "answer": "STATE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "What you step on to check your weight",
                "answer": "SCALE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A sharp claw on an eagle or hawk",
                "answer": "TALON",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Roughly; approximately",
                "answer": "ABOUT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A soft grayish-brown shade, popular for paint",
                "answer": "TAUPE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A respected senior member of a community",
                "answer": "ELDER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A secret group plotting together",
                "answer": "CABAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Spoken so others can hear, not silently",
                "answer": "ALOUD",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A jeweler's small magnifying eyepiece",
                "answer": "LOUPE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Step through the doorway",
                "answer": "ENTER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0034",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To own or possess something",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One of two equal parts",
                "answer": "HALF",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Turn aside to prevent trouble",
                "answer": "AVERT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A moving picture, as on a screen",
                "answer": "VIDEO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Keen and excited to begin",
                "answer": "EAGER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Having to do with birds",
                "answer": "AVIAN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A cozy home built by a bird",
                "answer": "NEST",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A narrow shelf, as on a cliff or wall",
                "answer": "LEDGE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Lets go without charge, as a prisoner",
                "answer": "FREES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A wrongful act in the eyes of the law",
                "answer": "TORT",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0035",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The opposite of \"that\"",
                "answer": "THIS",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In that place, not here",
                "answer": "THERE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The joint a door swings on",
                "answer": "HINGE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Closest to the center",
                "answer": "INNER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Vast bodies of saltwater",
                "answer": "SEAS",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Old-fashioned word for \"yours\"",
                "answer": "THINE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The dull sound of something heavy dropping",
                "answer": "THUD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A reddish dye used to color hair",
                "answer": "HENNA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Strongly encourages, with \"on\"",
                "answer": "URGES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A forest animal with antlers",
                "answer": "DEER",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0036",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good purpose; make ___ of",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bring together as one",
                "answer": "UNITE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Without, in fancy French-flavored talk",
                "answer": "SANS",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A small rough spot or catch in fabric",
                "answer": "SNAG",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A chair or bench to sit on",
                "answer": "SEAT",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Existing, alive; a human ___",
                "answer": "BEING",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A large snake that squeezes its prey",
                "answer": "BOA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Grain in your morning porridge",
                "answer": "OATS",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0037",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put down in place, as a table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not quick; taking your time",
                "answer": "SLOW",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Every single one",
                "answer": "EACH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The grooved surface of a tire",
                "answer": "TREAD",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A young grub before it becomes a beetle or moth",
                "answer": "LARVA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A poetic word for a valley",
                "answer": "VALE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Once more; starting fresh",
                "answer": "ANEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A vast body of saltwater, like the Atlantic",
                "answer": "OCEAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The giant gentle creature of the sea",
                "answer": "WHALE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Morning moisture on the grass",
                "answer": "DEW",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0038",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take in with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A weighing device, as for fish or flour",
                "answer": "SCALE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Ahead of the usual time",
                "answer": "EARLY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Host who keeps a show moving along",
                "answer": "EMCEE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Tricks meant to cheat people of money",
                "answer": "SCAMS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A place for a relaxing soak and massage",
                "answer": "SPA",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Bashful and timid",
                "answer": "SHY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Dry out by scorching heat",
                "answer": "PARCH",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A narrow lane between buildings",
                "answer": "ALLEY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you see with",
                "answer": "EYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0039",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"All ___ one\" — that is, except one",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One stroke over par in golf",
                "answer": "BOGEY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Look after, as a garden or a fire",
                "answer": "TEND",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The range of what something covers or includes",
                "answer": "SCOPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Wipe gently, as a cotton ball on a cut",
                "answer": "SWAB",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Arrived, in past tense",
                "answer": "CAME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A horse-drawn cart for hauling goods",
                "answer": "WAGON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Make a change or correction to",
                "answer": "AMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A title for a ruler in old Turkey",
                "answer": "BEY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0040",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Grain that horses love to munch",
                "answer": "OATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Away from home, as when running errands",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Japanese-style cartoons",
                "answer": "ANIME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Worn out and sleepy",
                "answer": "TIRED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "In place of, as in \"in his ___\"",
                "answer": "STEAD",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single whole thing in a set",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Rubber wheels on a car",
                "answer": "TIRES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A pen where pigs are kept",
                "answer": "STY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Beef, chicken, or pork",
                "answer": "MEAT",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A small swirling whirlpool in a stream",
                "answer": "EDDY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0041",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Quiet and motionless",
                "answer": "STILL",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A mischievous, playful rascal",
                "answer": "SCAMP",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Something forbidden by custom",
                "answer": "TABOO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fill thoroughly, as with color or feeling",
                "answer": "IMBUE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The smallest amount, as in \"the very ___\"",
                "answer": "LEAST",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Misplaces, as one's keys",
                "answer": "LOSES",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A small carved portrait worn as a brooch",
                "answer": "CAMEO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Religious leaders in some traditions",
                "answer": "ABBAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A small creature that scurries from cats",
                "answer": "MOUSE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Writers of verse",
                "answer": "POETS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0042",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To hold or possess",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Come to a full stop",
                "answer": "HALT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Sharp and bitter in tone",
                "answer": "ACERB",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Absolutely necessary for life",
                "answer": "VITAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Draw out or bring forth, as a reaction",
                "answer": "EDUCE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Sour substances, like lemon juice or vinegar",
                "answer": "ACIDS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Spit out or eject forcefully",
                "answer": "SPEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A pause or break in the action",
                "answer": "LETUP",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A faint mark or hint left behind",
                "answer": "TRACE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Was carried off by the wind, in past tense",
                "answer": "BLEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0043",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To possess or own",
                "answer": "HAVE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Split into two equal portions",
                "answer": "HALVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Like a bird, or relating to birds",
                "answer": "AVIAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Openings that let air pass through",
                "answer": "VENTS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The rim or border of a table",
                "answer": "EDGE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Kept from harm or set aside, in past tense",
                "answer": "SAVED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A man from north of England's border, by Edinburgh",
                "answer": "SCOT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Hold on tightly, as ivy to a wall",
                "answer": "CLING",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Shaped like an egg",
                "answer": "OVATE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The numbers in the column after units",
                "answer": "TENS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0044",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Last ___ not least\"",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A natural community of plants and animals",
                "answer": "BIOME",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse an action; cancel out",
                "answer": "UNDO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Very small; the tiniest size",
                "answer": "MINI",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "An entertainer who performs without words",
                "answer": "MIME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A tiny part in radios and electronics",
                "answer": "DIODE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A child's affectionate name for father",
                "answer": "DAD",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Bullets and shells, informally",
                "answer": "AMMO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The letter after \"C,\" spelled out",
                "answer": "DEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0045",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Belonging to that woman",
                "answer": "HER",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The sound a snake makes",
                "answer": "HISS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A sound bouncing back off a canyon wall",
                "answer": "ECHO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A large animal with a horn on its nose",
                "answer": "RHINO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A clear fluid in the veins of mythical gods",
                "answer": "ICHOR",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Egg-shaped, like a racetrack",
                "answer": "OVAL",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Uncommon; not often seen",
                "answer": "RARE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A Hindu god, one of the great three",
                "answer": "SHIVA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Device that finds objects underwater with sound",
                "answer": "SONAR",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A cheer shouted at a bullfight",
                "answer": "OLE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0046",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single deed or a part of a play",
                "answer": "ACT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A remark spoken to oneself, off to the side",
                "answer": "ASIDE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A seat with a back and four legs",
                "answer": "CHAIR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Canvas shelters used for camping",
                "answer": "TENTS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "What remains after a fire burns out",
                "answer": "ASHES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A clever monkey-like animal, such as a chimp",
                "answer": "APE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A distress signal in Morse code",
                "answer": "SOS",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A grand instrument with black and white keys",
                "answer": "PIANO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Corrects and trims a piece of writing",
                "answer": "EDITS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Hesitation sounds in speech, written out",
                "answer": "ERS",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0047",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Perform on a stage",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A protein found in muscle fibers",
                "answer": "ACTIN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Look after with tenderness",
                "answer": "CARE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A hammer or wrench, for instance",
                "answer": "TOOL",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Tropical bean from which chocolate is made",
                "answer": "CACAO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Study hard at the last minute, as for an exam",
                "answer": "CRAM",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Prefix meaning \"air,\" as in plane design",
                "answer": "AERO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "In a style from years gone by",
                "answer": "RETRO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The little mermaid of Disney fame",
                "answer": "ARIEL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Short for the day after Sunday",
                "answer": "MON",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0048",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A smooth, fine cloth spun by worms",
                "answer": "SILK",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put in place, as a table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Creamy white material from elephant tusks",
                "answer": "IVORY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A river of forgetfulness in Greek myth",
                "answer": "LETHE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Bend down on bended knee",
                "answer": "KNEEL",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Smooth and flat; also a number divisible by two",
                "answer": "EVEN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Carried about, in past tense",
                "answer": "TOTED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A spiced lentil dish from India",
                "answer": "DAL",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A large flightless bird of South America",
                "answer": "RHEA",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Shout at the top of your voice",
                "answer": "YELL",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0049",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"___ one would you like?\"",
                "answer": "WHICH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "An old American political party of Lincoln's day",
                "answer": "WHIGS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A many-headed monster of Greek legend",
                "answer": "HYDRA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Just perfect; couldn't be better",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A tall wading bird, or a lifting machine",
                "answer": "CRANE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "People who welcome guests into their home",
                "answer": "HOSTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Prefix for power made from running water",
                "answer": "HYDRO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Thoughts or plans that pop into your head",
                "answer": "IDEAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Money given to support a cause or student",
                "answer": "GRANT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bargains at the shop; January clearance ___",
                "answer": "SALES",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0050",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The opposite of \"that\"",
                "answer": "THIS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A snare for catching a mouse",
                "answer": "TRAP",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Tall points on a graph or mountain range",
                "answer": "HIGHS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Just right for the purpose",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Good judgment; \"common ___\"",
                "answer": "SENSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Trips on a bus, bike, or horse",
                "answer": "RIDES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A hearty pot of meat and vegetables",
                "answer": "STEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A spy, or someone who acts on your behalf",
                "answer": "AGENT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A stage or step in a process",
                "answer": "PHASE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A great many; \"a whole ___ of people\"",
                "answer": "SLEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0051",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "After that; what happens next",
                "answer": "THEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Over yonder, not here",
                "answer": "THERE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Gaps or openings, as in a fence",
                "answer": "HOLES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Put into effect, as a new law",
                "answer": "ENACT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Coming up right after; \"the ___ in line\"",
                "answer": "NEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Gadget for making a call",
                "answer": "PHONE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Get ready ahead of time",
                "answer": "PREP",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Unwind and take it easy",
                "answer": "RELAX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Stand up straight and tall",
                "answer": "ERECT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A bothersome bug in the garden",
                "answer": "PEST",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0052",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look; \"come and ___\"",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word said when you feel regret",
                "answer": "SORRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Wicked; the opposite of good",
                "answer": "EVIL",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Have a meal",
                "answer": "EAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A bright new star that suddenly flares up",
                "answer": "NOVA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Close by, not far",
                "answer": "NEAR",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Worthiness deserving of reward or praise",
                "answer": "MERIT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Came together, in past tense",
                "answer": "MET",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A nobleman ranking below a marquess",
                "answer": "EARL",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Give it a go; make an attempt",
                "answer": "TRY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0053",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word before \"end\" or \"best\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "And so; therefore",
                "answer": "THUS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Lend a hand to someone in need",
                "answer": "HELP",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One who dines; a hearty ___",
                "answer": "EATER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Large piles, as of laundry or leaves",
                "answer": "HEAPS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Say words to heaven; kneel and ___",
                "answer": "PRAY",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "For the benefit of; \"for goodness' ___\"",
                "answer": "SAKE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Extreme; far beyond the ordinary",
                "answer": "ULTRA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Say words aloud; talk",
                "answer": "SPEAK",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Grain used in some whiskeys and breads",
                "answer": "RYE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0054",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"A letter ___ you arrived today\"",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Let go from a job, in past tense",
                "answer": "FIRED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A small green or black fruit, often in salads",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sticky tree sap, used to make varnish",
                "answer": "RESIN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Placed papers neatly in a cabinet",
                "answer": "FILED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A passing craze or trend",
                "answer": "FAD",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Abbreviation for a politician's helper",
                "answer": "DEL",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Get up onto your feet; stand and ___",
                "answer": "ARISE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A wicked spirit with horns and a tail",
                "answer": "DEVIL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0055",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This bouquet is ___ you, dear\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Held firmly in place; not loose",
                "answer": "FIXED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Welcoming customers; \"the shop is ___\"",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A pause to catch your breath",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Slide your card to pay",
                "answer": "SWIPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A quick poke or thrust",
                "answer": "STAB",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Money earned for a week's work",
                "answer": "WAGE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Money the government collects each April",
                "answer": "TAXES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A representative who acts on your behalf",
                "answer": "AGENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Where you lay your head at night",
                "answer": "BED",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0056",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Greasy parts trimmed off a steak",
                "answer": "FATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"Three cheers ___ the winner!\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Steer clear of; stay away from",
                "answer": "AVOID",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A warm golden-brown color, as of an owl",
                "answer": "TAWNY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A clean blackboard you write on with chalk",
                "answer": "SLATE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Egg-shaped, like a mirror frame",
                "answer": "OVAL",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A tree with bright red autumn berries",
                "answer": "ROWAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "\"Neither here ___ there\"",
                "answer": "NOR",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Heading toward the inside",
                "answer": "INTO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "One who colors fabric or cloth",
                "answer": "DYER",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0057",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Roughly; \"___ ten o'clock\"",
                "answer": "ABOUT",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Religious leaders in certain faiths",
                "answer": "ABBAS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The thinking organ inside your head",
                "answer": "BRAIN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Get the better of; surpass in a contest",
                "answer": "OUTDO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A polite person who shows guests to their seats",
                "answer": "USHER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "\"___ days are the best,\" pointing nearby",
                "answer": "THESE",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sweep with bristles, as your teeth or hair",
                "answer": "BRUSH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wash yourself in the tub",
                "answer": "BATHE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Helpers or assistants to important people",
                "answer": "AIDES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The rumbling sound of deep sleep",
                "answer": "SNORE",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0058",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A great deal; not little",
                "answer": "MUCH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Gentle and not harsh, as a winter or a cheese",
                "answer": "MILD",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A joining together; a labor ___",
                "answer": "UNION",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "An exact copy of a living thing",
                "answer": "CLONE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A reddish-brown dye used on hair",
                "answer": "HENNA",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A small bay or arm of water",
                "answer": "INLET",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The emperor of old Russia",
                "answer": "TSAR",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The big cats with manes, kings of the jungle",
                "answer": "LIONS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A woman's name, as in Prima ___",
                "answer": "DONNA",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Close by; \"the shop is quite ___\"",
                "answer": "NEAR",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0059",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Similar to; \"she looks ___ her mother\"",
                "answer": "LIKE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A bank built to hold back a flooding river",
                "answer": "LEVEE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Just right; a perfect match",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Bends and twists, as in a garden hose",
                "answer": "KINKS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Simple and free of trouble",
                "answer": "EASY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Newspapers, radio, and television together",
                "answer": "MEDIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A small dark spot on the skin",
                "answer": "MOLE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Hot boxes for baking bread and cakes",
                "answer": "OVENS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Letting drops seep through, as a worn roof",
                "answer": "LEAKY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Long slippery fish that look like snakes",
                "answer": "EELS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0060",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This song is just ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Senses by touch; \"it ___ soft\"",
                "answer": "FEELS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A sign of things to come",
                "answer": "OMEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A small tear in your trousers",
                "answer": "RIP",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A truck cab without its trailer",
                "answer": "SEMI",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The lower leg, below the knee",
                "answer": "SHIN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Woolly farm animals that say \"baa\"",
                "answer": "SHEEP",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Slide down a snowy slope on two long boards",
                "answer": "SKI",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A hot oven for hardening clay pots",
                "answer": "KILN",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The opposite of \"outs\"",
                "answer": "INS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0061",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single scene in a stage play",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sour liquid, the opposite of a base in chemistry",
                "answer": "ACID",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Secret set of letters or numbers for entry",
                "answer": "CODE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A general direction things are heading",
                "answer": "TREND",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The very centers of apples",
                "answer": "CORES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "To lessen or relieve discomfort",
                "answer": "EASE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A great many; a large number",
                "answer": "SLEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Perfect; just right",
                "answer": "IDEAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Thick and packed tightly together",
                "answer": "DENSE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Tiny droplets found on morning grass",
                "answer": "DEW",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0063",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Up to the time of; not before",
                "answer": "UNTIL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Spotted with the eyes",
                "answer": "SEEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A small whirlpool of water",
                "answer": "EDDY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Firm and well-exercised, as muscles",
                "answer": "TONED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Doughnut-shaped rings, in geometry",
                "answer": "TORI",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A shimmering, milky-colored gemstone",
                "answer": "OPAL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Chose to do something",
                "answer": "OPTED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wet and drizzly, as some weather",
                "answer": "RAINY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Not feeling well",
                "answer": "ILL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0064",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Destiny; what is meant to be",
                "answer": "FATE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "On behalf of; in favor of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Steer clear of; keep away from",
                "answer": "AVOID",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Light brownish-yellow, like a lion's coat",
                "answer": "TAWNY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "To fill with great joy",
                "answer": "ELATE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Egg-like shape, like a racetrack",
                "answer": "OVAL",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A tree with bright red berries",
                "answer": "ROWAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Refusals; words of denial",
                "answer": "NOS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Heading toward the inside of",
                "answer": "INTO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Colors fabric soaks up to change its shade",
                "answer": "DYES",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0065",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Strength or might to get things done",
                "answer": "POWER",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A follower of ancient nature worship",
                "answer": "PAGAN",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Small green fruit pressed for cooking oil",
                "answer": "OLIVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Married women, in older usage",
                "answer": "WIVES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "To turn inside out",
                "answer": "EVERT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Monthly payments a tenant makes",
                "answer": "RENTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Still breathing and well",
                "answer": "ALIVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Handed over or provided",
                "answer": "GIVEN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "To turn aside and prevent",
                "answer": "AVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Cozy homes birds build in trees",
                "answer": "NESTS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0066",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To possess or own",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "To bring to a sudden stop",
                "answer": "HALT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Sharp and bitter in tone or taste",
                "answer": "ACERB",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Absolutely essential to life",
                "answer": "VITAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "To draw out or bring forth",
                "answer": "EDUCE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Sour substances on the chemistry shelf",
                "answer": "ACIDS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Moved very fast",
                "answer": "SPED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A pause or easing, as in rain",
                "answer": "LETUP",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A faint mark or hint left behind",
                "answer": "TRACE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Lost a little redness from a small cut",
                "answer": "BLED",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0067",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To create or build something",
                "answer": "MAKE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In a wild or frantic way",
                "answer": "MADLY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The corner where two lines meet",
                "answer": "ANGLE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "To work dough with the hands",
                "answer": "KNEAD",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Simple; not hard at all",
                "answer": "EASY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Heavenly food in a Bible story",
                "answer": "MANNA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Honey wine of old",
                "answer": "MEAD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The outer borders or rims",
                "answer": "EDGES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "To calm or soothe a worry",
                "answer": "ALLAY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Colored cloth using a tint",
                "answer": "DYED",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0068",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Place down in position",
                "answer": "SET",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Heat-resistant glass for the kitchen",
                "answer": "SILEX",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "To give off, as light or heat",
                "answer": "EMIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The highest point",
                "answer": "TOP",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Long, fancy car for special occasions",
                "answer": "LIMO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Slippery oil for a squeaky hinge",
                "answer": "LUBE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Cup-shaped spring flower from a bulb",
                "answer": "TULIP",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sticky black stuff used to pave roads",
                "answer": "TAR",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "To help or assist, often in wrongdoing",
                "answer": "ABET",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Latin title meaning 'king'",
                "answer": "REX",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0069",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Adjust a clock to the right time",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Smooth, luxurious fabric from worms' threads",
                "answer": "SILK",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Level and flat, or a number divisible by two",
                "answer": "EVEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Carved tribal pole or symbol",
                "answer": "TOTEM",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Creamy-white material from elephant tusks",
                "answer": "IVORY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Large flightless bird of South America",
                "answer": "RHEA",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Sharp cry a hurt dog makes",
                "answer": "YELP",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "River of forgetfulness in Greek myth",
                "answer": "LETHE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Bend down on bent legs to pray",
                "answer": "KNEEL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Folded paper guide for finding your way",
                "answer": "MAP",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0070",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take steps; do something",
                "answer": "ACT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Following in time; later than",
                "answer": "AFTER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Raccoon-like animal of the tropics",
                "answer": "COATI",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Bright spring flower grown from a bulb",
                "answer": "TULIP",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Tangled up or in trouble with",
                "answer": "AFOUL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Slithering snake of Egypt",
                "answer": "ASP",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Allow or permit",
                "answer": "LET",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "No longer fresh, as old bread",
                "answer": "STALE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Small, as in 'a small jury'",
                "answer": "PETIT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Tear apart at a seam",
                "answer": "RIP",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0071",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "No longer in the game, in baseball",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sixteen of these make a pound",
                "answer": "OUNCE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A strong wish or impulse",
                "answer": "URGE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Title of an old Russian emperor",
                "answer": "TSAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Pointed wheels on a cowboy's boots",
                "answer": "SPURS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Shock into being unable to move",
                "answer": "STUN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A long, slender wooden rod",
                "answer": "POLE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Island kingdom in the South Pacific",
                "answer": "TONGA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A painful open sore",
                "answer": "ULCER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Word before a maiden name",
                "answer": "NEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0072",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Resorts where folks go to relax and soak",
                "answer": "SPAS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Take a look at",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Out of style; old-fashioned",
                "answer": "PASSE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Stubborn donkeys",
                "answer": "ASSES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sharply sloped, like a hillside",
                "answer": "STEEP",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Direction where the sun rises",
                "answer": "EAST",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Plural of a curvy letter of the alphabet",
                "answer": "ESSES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "The blue expanse overhead",
                "answer": "SKY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Go looking for",
                "answer": "SEEK",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Catch sight of in the distance",
                "answer": "ESPY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0073",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Calm and quiet, without movement",
                "answer": "STILL",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Very common English last name",
                "answer": "SMITH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Small fish popular in home aquariums",
                "answer": "TETRA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Perfect or just right",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The most allowed; a boundary",
                "answer": "LIMIT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Goes on and on, or remains",
                "answer": "LASTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Newspapers, TV, and radio together",
                "answer": "MEDIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Things on a to-do list",
                "answer": "ITEMS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A distinguishing quality of someone",
                "answer": "TRAIT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Brings to a stop",
                "answer": "HALTS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0074",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To hold or own",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sound of cheerful laughter",
                "answer": "HAHA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A loud warning bell or buzzer",
                "answer": "ALARM",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Lines of a poem set in rhythm",
                "answer": "VERSE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A mistake or slip-up",
                "answer": "ERROR",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Watchful and ready for action",
                "answer": "ALERT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "River that flows through Newcastle, England",
                "answer": "TYNE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "First name of England's Prince, brother of William",
                "answer": "HARRY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Crime of deliberately setting fire",
                "answer": "ARSON",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Nothing more than; only",
                "answer": "MERE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0075",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Way up tall, like a skyscraper",
                "answer": "HIGH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Many-headed serpent of Greek legend",
                "answer": "HYDRA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Just right; the model of perfection",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Smoothness and charm in movement",
                "answer": "GRACE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "One who welcomes guests to a party",
                "answer": "HOST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Prefix meaning 'water,' as in power plants",
                "answer": "HYDRO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Successful songs on the radio",
                "answer": "HITS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Bright thoughts and plans",
                "answer": "IDEAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A stretch of land, or a pamphlet",
                "answer": "TRACT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A store's big bargain event",
                "answer": "SALE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0077",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A law passed by lawmakers",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Weapons used by soldiers",
                "answer": "ARMS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Black rock burned for fuel",
                "answer": "COAL",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Set to the right pitch, as a piano",
                "answer": "TUNED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bumpy and not smooth",
                "answer": "ROUGH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Pure happiness and delight",
                "answer": "GLEE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Big, splashy promotion or buzz",
                "answer": "HYPE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Brave and strong, in a traditional sense",
                "answer": "MANLY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you do each night to rest",
                "answer": "SLEEP",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "River in northern England, or the letter D spelled out",
                "answer": "DEE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0078",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "V",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "From a past time up to now",
                "answer": "SINCE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A way in, or a record in a logbook",
                "answer": "ENTRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Spooky and strange in a chilling way",
                "answer": "EERIE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Climbing plants like grapes grow on",
                "answer": "VINES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "By way of; passing through",
                "answer": "VIA",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A square of grassy turf",
                "answer": "SOD",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The opening part of a song or book",
                "answer": "INTRO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sharp and bitter to the nose or taste",
                "answer": "ACRID",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you see with",
                "answer": "EYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0079",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "V",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put in place; ready to go",
                "answer": "SET",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Locations or building plots",
                "answer": "SITES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Smooth and level, or a tied score",
                "answer": "EVEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A quiz or examination",
                "answer": "TEST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Small green fruit used to make a martini",
                "answer": "OLIVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Across the top of; above",
                "answer": "OVER",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Deep, caring affection",
                "answer": "LOVE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Marks cast in an election",
                "answer": "VOTES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A happening or special occasion",
                "answer": "EVENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Short for 'residence,' on an address line",
                "answer": "RES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0080",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Large, shimmering deep-sea fish",
                "answer": "OPAH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "No longer batting, in baseball",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Roam about quietly, like a cat hunting",
                "answer": "PROWL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "To be of the same mind",
                "answer": "AGREE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The organ that beats in your chest",
                "answer": "HEART",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A strong push to do something",
                "answer": "URGE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The sacred scroll of Jewish scripture",
                "answer": "TORAH",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "More than one fellow",
                "answer": "HES",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Used to be, said of a group",
                "answer": "WERE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Allows; gives permission to",
                "answer": "LETS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0081",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Coming before all others; number one",
                "answer": "FIRST",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not true; incorrect",
                "answer": "FALSE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Bright thoughts that pop into your head",
                "answer": "IDEAS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Old money units of Iran",
                "answer": "RIALS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Bring food to the table for guests",
                "answer": "SERVE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Melodies you hum along to",
                "answer": "TUNES",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Fond farewell, borrowed from French",
                "answer": "ADIEU",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Pick up new knowledge",
                "answer": "LEARN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Soothing ointment for the skin",
                "answer": "SALVE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "More than one curvy alphabet letter",
                "answer": "ESSES",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0082",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Be fond of; enjoy",
                "answer": "LIKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A narrow road or path",
                "answer": "LANE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Absolutely perfect",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Loose collarless shirt worn in South Asia",
                "answer": "KURTA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A young eel",
                "answer": "ELVER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A grown-up, not a child",
                "answer": "ADULT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The numbers 10 through 19, in a group",
                "answer": "TENS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Boldness, or a bundle of fibers in the body",
                "answer": "NERVE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Consumed at the dinner table",
                "answer": "EATEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "More than one fellow named for a Roman first name",
                "answer": "LARS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0083",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Require; must have",
                "answer": "NEED",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One who cares for hospital patients",
                "answer": "NURSE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Rub out a pencil mark",
                "answer": "ERASE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The older of two, or a respected senior",
                "answer": "ELDER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Adds color to fabric or eggs",
                "answer": "DYES",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Grumpy and unfriendly",
                "answer": "SURLY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A quick poke, or an attempt at something",
                "answer": "STAB",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Buying and selling between businesses",
                "answer": "TRADE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Long-eared, stubborn farm animals",
                "answer": "ASSES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Drink poured from a tap at the pub",
                "answer": "BEER",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0084",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of; in support of",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The border around a picture",
                "answer": "FRAME",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Greasy; slick with grease",
                "answer": "OILY",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A beam of sunshine",
                "answer": "RAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A solo song in an opera",
                "answer": "ARIA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A measure of land, about a football field",
                "answer": "ACRE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Covered in flaky skin, like a fish",
                "answer": "SCALY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Droop or sink downward in the middle",
                "answer": "SAG",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A nation's land forces",
                "answer": "ARMY",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Cry of encouragement to a horse",
                "answer": "GEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0085",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single part of a play",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In addition; as well",
                "answer": "ALSO",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Phone someone up",
                "answer": "CALL",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Locomotive pulling rail cars",
                "answer": "TRAIN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A young insect, like a caterpillar",
                "answer": "LARVA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cheer of 'long live!' in Spanish or Italian",
                "answer": "VIVA",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fresh and once again",
                "answer": "ANEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Struck down in battle, in older language",
                "answer": "SLAIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Small green fruit used for oil or garnish",
                "answer": "OLIVE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Casual way of saying 'no'",
                "answer": "NAW",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0086",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take notice of with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Speedy blue video-game hedgehog",
                "answer": "SONIC",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Keen and enthusiastic",
                "answer": "EAGER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Each and all of them",
                "answer": "EVERY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A crisp, dry Italian white wine",
                "answer": "SOAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Was seated, in the past tense",
                "answer": "SAT",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Plural ending often added to make a verb",
                "answer": "ERS",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Strong feeling of being cross or upset",
                "answer": "ANGER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Rows or layers of seating in a stadium",
                "answer": "TIERS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Weep with tears",
                "answer": "CRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0087",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On the other hand; however",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Started; got under way",
                "answer": "BEGAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A trial or examination",
                "answer": "TEST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Thin French pancake",
                "answer": "CREPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Soft earth a potter shapes",
                "answer": "CLAY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Wander about freely",
                "answer": "ROVE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Company emblems or symbols",
                "answer": "LOGOS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Ahead of its time, as in art",
                "answer": "AVANT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Japan's unit of money",
                "answer": "YEN",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0088",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Drive out of office or power",
                "answer": "OUST",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not at home; away from the inside",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The way something is used",
                "answer": "USAGE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Identified by gender, as a noun in some languages",
                "answer": "SEXED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Gave something a go",
                "answer": "TRIED",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "One who operates a machine or product",
                "answer": "USER",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cabs that pick you up on the street",
                "answer": "TAXIS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "What you look up at on a clear day",
                "answer": "SKY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A clever, tech-loving enthusiast",
                "answer": "GEEK",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A swirl in a stream of water",
                "answer": "EDDY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0089",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Energy or muscle to act",
                "answer": "POWER",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Worshipper of old nature gods",
                "answer": "PAGAN",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Small green fruit grown around the Mediterranean",
                "answer": "OLIVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Married women, in old-fashioned speech",
                "answer": "WIVES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Turn outward or inside out",
                "answer": "EVERT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Takes a break; relaxes",
                "answer": "RESTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Still here and breathing",
                "answer": "ALIVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Hands over freely",
                "answer": "GIVES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Steer away to avoid trouble",
                "answer": "AVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Snug homes for baby birds",
                "answer": "NESTS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0090",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Have a taste for; enjoy",
                "answer": "LIKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Run with long, easy strides",
                "answer": "LOPE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Exactly right; a model example",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Affectionate name for a house cat",
                "answer": "KITTY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A sweet-smelling compound in fruit and perfume",
                "answer": "ESTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A writer of lofty poems of praise",
                "answer": "ODIST",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "River by Newcastle in northern England",
                "answer": "TYNE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Small-minded, or a minor amount of cash",
                "answer": "PETTY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Finished off a meal",
                "answer": "EATEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Harp-like instrument of ancient Greece",
                "answer": "LYRE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0091",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In good health, feeling fine",
                "answer": "WELL",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Flinch in pain",
                "answer": "WINCE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The joint in the middle of your arm",
                "answer": "ELBOW",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Pick up a new skill",
                "answer": "LEARN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small harp once played in ancient Greece",
                "answer": "LYRE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Cartoon dog famous as a comic-strip pet",
                "answer": "RILEY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A sudden hurry, or the thrill of excitement",
                "answer": "RUSH",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Lift the bolt and let someone in",
                "answer": "UNBAR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Tally of points in a game",
                "answer": "SCORE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Cut and shaped from rough timber or stone",
                "answer": "HEWN",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0092",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of, or in favor of",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A great noisy uproar",
                "answer": "FUROR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Not shut",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rodent that scurries through the cellar",
                "answer": "RAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Young insect inside its cocoon",
                "answer": "PUPA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Peel the skin from an apple",
                "answer": "PARE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The little mark a printer uses to show where words go in",
                "answer": "CARET",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "On the near side, in scientific terms",
                "answer": "CIS",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Press wrinkles out of a shirt",
                "answer": "IRON",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Title before a Spanish gentleman's name",
                "answer": "SER",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0093",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take steps to get something done",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A region or open space",
                "answer": "AREA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Thick rope or string for tying bundles",
                "answer": "CORD",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fortune-teller's deck of fancy cards",
                "answer": "TAROT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cook a chicken in the oven",
                "answer": "ROAST",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cries that shake the shoulders",
                "answer": "SOBS",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A long hike through the wilderness",
                "answer": "TREK",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A mistake or slip-up",
                "answer": "ERROR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sun-dried mud brick used in Southwest homes",
                "answer": "ADOBE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Sound of mild disapproval, with the tongue",
                "answer": "TSK",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0094",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Notice with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Long-billed marsh bird, also a hunter's target",
                "answer": "SNIPE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The way in, or a line written in a diary",
                "answer": "ENTRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Strange and spooky",
                "answer": "EERIE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Closer to the middle",
                "answer": "INNER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Connections that help you get a foot in the door",
                "answer": "INS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What spoiled fruit does",
                "answer": "ROT",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Explosive liquid, short for a famous powerful compound",
                "answer": "NITRO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The pole that holds up the front of a sailboat",
                "answer": "SPRIT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you see with",
                "answer": "EYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0095",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not inside, in the fresh air",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A small weight, sixteen to the pound",
                "answer": "OUNCE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A strong desire or longing",
                "answer": "URGE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Russian ruler of long ago",
                "answer": "TSAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sharp metal wheels on a cowboy's boots",
                "answer": "SPURS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The short end of a used ticket or pencil",
                "answer": "STUB",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Tall wooden post for a flag",
                "answer": "POLE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Island nation in the South Pacific",
                "answer": "TONGA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Painful open sore in the stomach",
                "answer": "ULCER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Buzzing honey-maker",
                "answer": "BEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0096",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Jazzy nonsense singing without real words",
                "answer": "SCAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Group of related items, like dishes or tools",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A merry Christmas song",
                "answer": "CAROL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A private remark made to one side",
                "answer": "ASIDE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Playful word for small children",
                "answer": "TYKES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Not hard at all",
                "answer": "EASY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A child's three-wheeled riding toy",
                "answer": "TRIKE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "The letter S, spelled out",
                "answer": "ESS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Poems of praise",
                "answer": "ODES",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A smaller amount",
                "answer": "LESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0097",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Roughly, give or take",
                "answer": "ABOUT",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Units of farmland",
                "answer": "ACRES",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Cheer of praise for a female performer",
                "answer": "BRAVA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "On the far edge or outside",
                "answer": "OUTER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Making use of",
                "answer": "USING",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Not these, but the others over there",
                "answer": "THOSE",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A schoolyard sweetheart feeling",
                "answer": "CRUSH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Comparison of two numbers, like three to one",
                "answer": "RATIO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Numbers like two, four, and six",
                "answer": "EVENS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Nickname for an army sergeant",
                "answer": "SARGE",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0098",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Build or create something with your hands",
                "answer": "MAKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Affectionate name for mother",
                "answer": "MAMA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Honor given for an achievement",
                "answer": "AWARD",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The idea that good deeds come back to you",
                "answer": "KARMA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A blunder or wrong answer",
                "answer": "ERROR",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Mindful and informed about something",
                "answer": "AWARE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Jane of a famous Charlotte Bronte novel",
                "answer": "EYRE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Tie the knot, say 'I do'",
                "answer": "MARRY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Protective metal suit for a knight",
                "answer": "ARMOR",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Have the courage to try",
                "answer": "DARE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0099",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In addition, as well",
                "answer": "ALSO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A large stadium for sports or shows",
                "answer": "ARENA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A bar used to pry something open",
                "answer": "LEVER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Gives the impression of being",
                "answer": "SEEMS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Solely, and no more",
                "answer": "ONLY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Color of grass and spring leaves",
                "answer": "GREEN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cheerful delight and merriment",
                "answer": "GLEE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Flat and even, like a still floor",
                "answer": "LEVEL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A foe or opponent",
                "answer": "ENEMY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you listen with",
                "answer": "EARS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0100",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single deed, or a part of a play",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In front, leading the way",
                "answer": "AHEAD",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A place to pitch a tent for the night",
                "answer": "CAMP",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Word before 'best' or 'most'",
                "answer": "THE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Old title for the ruler of Persia",
                "answer": "SHAH",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small backyard storage building for tools",
                "answer": "SHED",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The main subject of a story or talk",
                "answer": "THEME",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Even so, in old-fashioned verse",
                "answer": "THO",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A big pile of sand or leaves",
                "answer": "HEAP",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Not even, like the number seven",
                "answer": "ODD",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0101",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Something done, a single deed",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Your two upper limbs",
                "answer": "ARMS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Warm garment worn over a shirt outdoors",
                "answer": "COAT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Catchy melodies you hum along to",
                "answer": "TUNES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Not smooth, bumpy to the touch",
                "answer": "ROUGH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Joy and merry good cheer",
                "answer": "GLEE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Loud excitement and fuss over something new",
                "answer": "HYPE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sturdy and brave, in an old-fashioned way",
                "answer": "MANLY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Very high and sharply sloped, like a cliff",
                "answer": "STEEP",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Use your eyes to look",
                "answer": "SEE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0102",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In place of, as a substitute",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put away in a folder or cabinet",
                "answer": "FILED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Green fruit pressed for cooking oil",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Red-breasted songbird of spring",
                "answer": "ROBIN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "One who flies the plane",
                "answer": "PILOT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Up to the time that, poetically",
                "answer": "TIL",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Proof of where you were at the time",
                "answer": "ALIBI",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Mischievous little imp with horns",
                "answer": "DEVIL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0103",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of someone",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Deadly, leading to the end",
                "answer": "FATAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Honest and aboveboard, with nothing hidden",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Monthly payment to the landlord",
                "answer": "RENT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The form or outline of something",
                "answer": "SHAPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Month abbreviated, ninth of the year",
                "answer": "SEPT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Hearty and healthy, full of vigor",
                "answer": "HALE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Chewed up and swallowed",
                "answer": "EATEN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Put a seed in the soil",
                "answer": "PLANT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Phone number abbreviation seen on old business cards",
                "answer": "TEL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0104",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Melt together, or blend into one",
                "answer": "FUSE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In support of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Stand a barrel on its end",
                "answer": "UPEND",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Reddish-brown tone of old photographs",
                "answer": "SEPIA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Put a new law into effect",
                "answer": "ENACT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Not closed",
                "answer": "OPEN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Pay back what you borrowed",
                "answer": "REPAY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A vote of yes",
                "answer": "YEA",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Pleasant and kind",
                "answer": "NICE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Facts and figures gathered for study",
                "answer": "DATA",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0105",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Different from this one",
                "answer": "OTHER",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Unlocks the door",
                "answer": "OPENS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A path through the woods",
                "answer": "TRAIL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Leafy garden plant grown for shady spots",
                "answer": "HOSTA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Each and all, without exception",
                "answer": "EVERY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Tries again, second attempts",
                "answer": "REDOS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Show beyond doubt that it is true",
                "answer": "PROVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Calmed down or relieved a pain",
                "answer": "EASED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Explosive liquid used to make dynamite, for short",
                "answer": "NITRO",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Knocks down with a sword, as a dragon",
                "answer": "SLAYS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0106",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Out of, starting at",
                "answer": "FROM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "College brotherhood, for short",
                "answer": "FRAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A deadly poison once feared in spy tales",
                "answer": "RICIN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Egg cell released by the body",
                "answer": "OVULE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Pairs of friends or partners",
                "answer": "MATES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A competitor you must beat",
                "answer": "RIVAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Smaller in amount",
                "answer": "LESS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sharp and severe, like a bad angle below ninety degrees",
                "answer": "ACUTE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Flat squares on a kitchen floor",
                "answer": "TILES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A point of land jutting into the sea, like Loch's neighbor",
                "answer": "NESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0107",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word used when comparing, as in 'better ___'",
                "answer": "THAN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A Scottish nobleman, as in Macbeth",
                "answer": "THANE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A great rush and hurry",
                "answer": "HASTE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Change or adjust a garment",
                "answer": "ALTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Close by, not far off",
                "answer": "NEAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Soft rock that splits into thin gray layers",
                "answer": "SHALE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Moved very quickly",
                "answer": "SPED",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Italian noodles, the foundation of many dinners",
                "answer": "PASTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Type in your password to sign in",
                "answer": "ENTER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Graceful woodland animal with antlers",
                "answer": "DEER",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0108",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put a tool to work",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Speak words aloud",
                "answer": "UTTER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Took someone to court",
                "answer": "SUED",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The finish, where things stop",
                "answer": "END",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Shock into stillness, knock senseless",
                "answer": "STUN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A grand, sweeping family tale",
                "answer": "SAGA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Marked out by destiny",
                "answer": "FATED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Plump, carrying extra weight",
                "answer": "FAT",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Grown old, like fine wine",
                "answer": "AGED",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sticky black road-paving stuff",
                "answer": "TAR",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0109",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In favor of something",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Cooking grease and lard",
                "answer": "FATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "An egg shape",
                "answer": "OVAL",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A small tree with bright red autumn berries",
                "answer": "ROWAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Stay away from, steer clear of",
                "answer": "AVOID",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Pour cream right ___ your coffee",
                "answer": "INTO",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Colored, like Easter eggs",
                "answer": "DYED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Golden-brown, like an autumn owl's feathers",
                "answer": "TAWNY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A clean board for writing, or a gray roofing stone",
                "answer": "SLATE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A little bow of the head meaning yes",
                "answer": "NOD",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0110",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However, on the other hand",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One stroke over par in golf",
                "answer": "FACET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of",
                "answer": "OTHER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Canvas shelter for camping",
                "answer": "REEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The full range or reach of something",
                "answer": "MATED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Clean a wound with cotton on a stick",
                "answer": "MOS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A bird's home up in a tree",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A cart pulled by horses or oxen",
                "answer": "OCHER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A secret operative or a salesperson",
                "answer": "SEEDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "An old title for a Turkish governor",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0111",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However, on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One stroke over par on a golf hole",
                "answer": "BOGEY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of, atop",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Canvas shelter pitched at a campsite",
                "answer": "TENT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The full range or reach of something",
                "answer": "SCOPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Clean a wound with cotton on a stick",
                "answer": "SWAB",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A barred home for a pet bird or zoo lion",
                "answer": "CAGE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A cart pulled by horses or oxen",
                "answer": "WAGON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A secret operative, or a salesperson",
                "answer": "AGENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "An old title for a Turkish governor",
                "answer": "BEY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0112",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Steady rhythm of a drum or a pulse",
                "answer": "BEAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word that joins two contrasting ideas",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Burst forth, as a volcano",
                "answer": "ERUPT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Reach the same understanding, see eye to eye",
                "answer": "AGREE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Strained and on edge, jittery",
                "answer": "TENSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A strong push or impulse to act",
                "answer": "URGE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Twists and bends in a winding road",
                "answer": "TURNS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A grassy clump dug up for a lawn",
                "answer": "SOD",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Coin and currency of Mexico",
                "answer": "PESO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Set the golf ball up on its little stand",
                "answer": "TEED",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0113",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "V",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "One of the fifty, like Texas or Maine",
                "answer": "STATE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Part of a fence, or a board in a barrel's side",
                "answer": "STAVE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flat squares covering a bathroom wall",
                "answer": "TILES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Call off a mission partway through",
                "answer": "ABORT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A faint trace of color",
                "answer": "TINGE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Keen and impatient to begin",
                "answer": "EAGER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The larger bone in your lower leg",
                "answer": "TIBIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Beside, or as time goes on",
                "answer": "ALONG",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The edge or brink of something",
                "answer": "VERGE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A fragrant chemical that gives fruit its smell",
                "answer": "ESTER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0114",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Possess or own",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Chop and fry potatoes, or make a jumbled mess of",
                "answer": "HASH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Distant and reserved, keeping to oneself",
                "answer": "ALOOF",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What something is worth",
                "answer": "VALUE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Correct the mistakes in a manuscript",
                "answer": "EMEND",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Famous old mission in San Antonio",
                "answer": "ALAMO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Chances or likelihood, as in betting",
                "answer": "ODDS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Fitted with new bottoms, as old shoes",
                "answer": "SOLED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A trailing dog that tracks by scent",
                "answer": "HOUND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Government agents, for short",
                "answer": "FEDS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0115",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Section or portion of a whole",
                "answer": "PART",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A pet annoyance or sore spot",
                "answer": "PEEVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The little plastic tip on the end of a shoelace",
                "answer": "AGLET",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Crumbling remains of an old castle",
                "answer": "RUINS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Words written on a page",
                "answer": "TEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Smoothly move from one tune right into the next",
                "answer": "SEGUE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Those women over there",
                "answer": "SHES",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Spiral shape of a winding staircase or DNA",
                "answer": "HELIX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "An occasion or happening",
                "answer": "EVENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Places where you sit, as in a theater",
                "answer": "SETS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0116",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch sight of",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wicked city of an old Bible story",
                "answer": "SODOM",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Wicked, the opposite of good",
                "answer": "EVIL",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A brand-new exploding star in the sky",
                "answer": "NOVA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Nothing at all, in Spanish",
                "answer": "NADA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The very lowest point",
                "answer": "NADIR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The writing tip of an old fountain pen",
                "answer": "NIB",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A statue or hero that people worship",
                "answer": "IDOL",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Comic-book sound of a hard hit",
                "answer": "BAM",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0117",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not in, but ___",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Breakfast cereal grain also fed to horses",
                "answer": "OATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single piece, one of a set",
                "answer": "UNIT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Flat squares laid on a kitchen counter",
                "answer": "TILES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Japanese style of cartoon film",
                "answer": "ANIME",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Breakfast, lunch, or supper",
                "answer": "MEAL",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A small swirl of water in a stream",
                "answer": "EDDY",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Covered with flat squares, as a floor",
                "answer": "TILED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "In place of, as in 'go in my ___'",
                "answer": "STEAD",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Crafty and clever, like a fox",
                "answer": "SLY",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0118",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch a glimpse of",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Brownish tint of an old-time photograph",
                "answer": "SEPIA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A bitter rival or foe",
                "answer": "ENEMY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Strange and ghostly",
                "answer": "EERIE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Make fresh again, as a magazine subscription",
                "answer": "RENEW",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "What decay does to a fallen log",
                "answer": "ROT",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A small bundle of cash or cotton",
                "answer": "WAD",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A grand musical drama with singing",
                "answer": "OPERA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Shy and easily frightened",
                "answer": "TIMID",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A sailor's word for yes",
                "answer": "AYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0119",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not in, but ___",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A small weight in the old measuring system",
                "answer": "OUNCE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A strong wish or craving",
                "answer": "URGE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Emperor of old Russia",
                "answer": "TSAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Pointed wheels on the heels of riding boots",
                "answer": "SPURS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A small post or earring, or a fine horse",
                "answer": "STUD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A tall wooden mast or beam",
                "answer": "POLE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Island country east of Australia",
                "answer": "TONGA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A sore that won't heal in the stomach",
                "answer": "ULCER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The fourth letter, spelled out",
                "answer": "DEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0120",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A dry crust that forms over a healing cut",
                "answer": "SCAB",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Lay eyes upon",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Find fault over little things, nitpick",
                "answer": "CAVIL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A quiet remark spoken to one person only",
                "answer": "ASIDE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small units of computer memory",
                "answer": "BYTES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Simple and effortless",
                "answer": "EASY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Online card sent to invite party guests",
                "answer": "EVITE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "The letter after R, written out",
                "answer": "ESS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The fifteenth day of March, in Roman times",
                "answer": "IDES",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A reduced amount",
                "answer": "LESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0121",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Once the show is over, we'll chat ___",
                "answer": "AFTER",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Heavenly being with wings and a halo",
                "answer": "ANGEL",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Enrico ___, famous Italian-born physicist",
                "answer": "FERMI",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Oaks, maples, and pines, as a group",
                "answer": "TREES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A wedding or a big concert, for example",
                "answer": "EVENT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rips or tears apart violently",
                "answer": "RENDS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sheer boldness; \"You've got some ___!\"",
                "answer": "NERVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Color of fresh grass and spring leaves",
                "answer": "GREEN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Correct or polish a piece of writing",
                "answer": "EMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Grocery rundowns and to-do notes",
                "answer": "LISTS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0122",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Be fond of, or similar to",
                "answer": "LIKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Strike of a whip, or part of the eye's fringe",
                "answer": "LASH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Absolutely perfect, just as you'd want it",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Loose collarless shirt worn in South Asia",
                "answer": "KURTA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Santa's little helpers at the North Pole",
                "answer": "ELVES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A grown-up, no longer a child",
                "answer": "ADULT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A quiz or examination at school",
                "answer": "TEST",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Dish up dinner, or start a tennis point",
                "answer": "SERVE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Strongly dislikes",
                "answer": "HATES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Final, coming at the very end",
                "answer": "LAST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0123",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Back ___, in those days",
                "answer": "THEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Swap goods, as in a fair barter",
                "answer": "TRADE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Things you clap and wave with",
                "answer": "HANDS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Outer rims of a table or a coin",
                "answer": "EDGES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Require, or a basic necessity",
                "answer": "NEED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A school mark like A, B, or C",
                "answer": "GRADE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Fond British nickname for one's father's mother",
                "answer": "GRAN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "How far a stove burner or a rifle can reach",
                "answer": "RANGE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Put in extra, as more salt to a soup",
                "answer": "ADDED",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Loch ___, home of a famous Scottish monster",
                "answer": "NESS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0124",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a bow after one, in a play",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Moving forward; full steam ___",
                "answer": "AHEAD",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Paper rectangle mailed at the holidays",
                "answer": "CARD",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Word before \"end\" or \"beginning\"",
                "answer": "THE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Old title for the ruler of Iran",
                "answer": "SHAH",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Backyard hut for storing tools",
                "answer": "SHED",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "In what place; \"___ are my glasses?\"",
                "answer": "WHERE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "\"Guess ___ is coming to dinner!\"",
                "answer": "WHO",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The part of you a hat sits on",
                "answer": "HEAD",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Unusual or strange, or not even",
                "answer": "ODD",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0125",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Brief part of a play between scenes",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Limbs you fold to give a hug",
                "answer": "ARMS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Black fuel once shoveled into furnaces",
                "answer": "COAL",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Melodies you can hum or whistle",
                "answer": "TUNES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bumpy and uneven, not smooth",
                "answer": "ROUGH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cheerful delight; \"full of ___\"",
                "answer": "GLEE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Loud build-up of excitement for a new film",
                "answer": "HYPE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Strong and rugged, in an old-fashioned way",
                "answer": "MANLY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "What you do every night in bed",
                "answer": "SLEEP",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Use your eyes to look at something",
                "answer": "SEE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0126",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Get your ___ together, in show business",
                "answer": "ACT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Walk ___, stroll beside someone",
                "answer": "ALONG",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A movie star's quick guest appearance",
                "answer": "CAMEO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A small gift, or a special snack for a dog",
                "answer": "TREAT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bell that rings to warn of fire or danger",
                "answer": "ALARM",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Boat that Noah built in the Bible",
                "answer": "ARK",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Up-to-date and fashionable, in 1960s slang",
                "answer": "MOD",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Juliet's young sweetheart in Shakespeare",
                "answer": "ROMEO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Press and fold dough for bread",
                "answer": "KNEAD",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Came into possession of; \"I ___ a letter\"",
                "answer": "GOT",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0127",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Slow ___ steady wins the race\"",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The skeleton's many parts",
                "answer": "BONES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of, like a hat on a head",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Lean toward, or care for someone who is sick",
                "answer": "TEND",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The range or reach of a project or study",
                "answer": "SCOPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A healed mark left on the skin",
                "answer": "SCAR",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Arrived at a place; \"she finally ___\"",
                "answer": "CAME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A respected rule or a body of sacred law",
                "answer": "CANON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Change a law to fix or improve it",
                "answer": "AMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Hotel guest on a register, for short",
                "answer": "RES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0128",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Take ___ piece of cake, please\"",
                "answer": "THAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Most common little word in English, before \"end\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Top notes a singer hits, or peaks on a chart",
                "answer": "HIGHS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Say yes, or share the same opinion",
                "answer": "AGREE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Over ___, in that spot away from here",
                "answer": "THERE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Tall, lofty, way up in the air",
                "answer": "HIGH",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Tall white wading bird seen in marshes",
                "answer": "EGRET",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Two thousand pounds, in weight",
                "answer": "TON",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Brave figure who saves the day",
                "answer": "HERO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Spotted or witnessed with your eyes",
                "answer": "SEEN",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0129",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Roughly, give or take; \"___ an hour\"",
                "answer": "ABOUT",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Soldiers gone missing from duty, in army slang",
                "answer": "AWOLS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Give a false picture of, or contradict",
                "answer": "BELIE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "More advanced in years",
                "answer": "OLDER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Putting to work, or by means of",
                "answer": "USING",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The ones right here, not those",
                "answer": "THESE",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Of the people and language of Wales",
                "answer": "WELSH",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A familiar old song you still love to hear",
                "answer": "OLDIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Legal claims placed against property for debts",
                "answer": "LIENS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Sturdy twilled fabric used for suits",
                "answer": "SERGE",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0130",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Labor at a job, or a finished piece of art",
                "answer": "WORK",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Gray animal that howls at the moon",
                "answer": "WOLF",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Drug from the poppy, used in old remedies",
                "answer": "OPIUM",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Wash the soap off under the tap",
                "answer": "RINSE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Joints in the middle of your legs",
                "answer": "KNEES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Express a view, or hold forth on a topic",
                "answer": "OPINE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Tail-end portions; loose ___",
                "answer": "ENDS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Cloth made from flax, used for fine sheets",
                "answer": "LINEN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Joined together by melting metal",
                "answer": "FUSED",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "An untidy heap or a jumbled situation",
                "answer": "MESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0131",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The folks over there, not us",
                "answer": "THEY",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Scottish lord, a title held by Macbeth",
                "answer": "THANE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Leafy garden plant prized for shady borders",
                "answer": "HOSTA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Go in through the doorway",
                "answer": "ENTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Twelve months on the calendar",
                "answer": "YEAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "How the sun looked when it gleamed brightly",
                "answer": "SHONE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Skewer for roasting meat over a fire",
                "answer": "SPIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Italian noodles served with sauce",
                "answer": "PASTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bury, as a body laid to rest",
                "answer": "INTER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A single drop that rolls down a cheek",
                "answer": "TEAR",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0132",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Do you ___ what I mean?",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Greek letter shaped like a capital E lying down, used for a sum",
                "answer": "SIGMA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A sound that bounces back in a canyon",
                "answer": "ECHO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Have a bite of breakfast or lunch",
                "answer": "EAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Glittery mineral that splits into thin sheets",
                "answer": "MICA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Silently act out a part, like Marcel Marceau",
                "answer": "MIME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "\"You just ___ be right about that\"",
                "answer": "MIGHT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Small rug you wipe your shoes on at the door",
                "answer": "MAT",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Bullets and shells, for short",
                "answer": "AMMO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Hot drink steeped from leaves in a cup",
                "answer": "TEA",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0133",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Last ___ not least\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Ali ___ and the Forty Thieves",
                "answer": "BABA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Worn out, like a secondhand car",
                "answer": "USED",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Beat strongly, as a heart might in your chest",
                "answer": "THROB",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Gray remains left after a fire",
                "answer": "ASHES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Charlotte Bronte's \"Jane ___\"",
                "answer": "EYRE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Wooden runner children ride down snowy hills",
                "answer": "SLED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Pale blue-green gemstone",
                "answer": "BERYL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Love and admire deeply",
                "answer": "ADORE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Where you tuck in for the night",
                "answer": "BED",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0134",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Better late ___ never\"",
                "answer": "BUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A gathered cluster of grapes or flowers",
                "answer": "BUNCH",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Join together, or come together as one",
                "answer": "UNITE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Kitchen gadget that counts down the minutes",
                "answer": "TIMER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Snug pullover top a soldier might wear",
                "answer": "TUNIC",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The \"way\" in Chinese philosophy",
                "answer": "TAO",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Whiskered pet that purrs on your lap",
                "answer": "CAT",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The soul or inner spirit, in psychology",
                "answer": "ANIMA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Group of eight musicians playing together",
                "answer": "OCTET",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Belonging to that woman",
                "answer": "HER",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0135",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"All ___ one, and one for all\"",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The bowl part of a kitchen sink",
                "answer": "BASIN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single item, or one part of a larger whole",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Try out a recipe, or a school exam",
                "answer": "TEST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Macbeth's title before he became king",
                "answer": "THANE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Old-fashioned jug shaped like a stout fellow",
                "answer": "TOBY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Long-eared cousin of the rabbit",
                "answer": "HARE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Green spot with water in the desert",
                "answer": "OASIS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Swedish actress Ekland's first name",
                "answer": "BRITT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Japanese money, by another name",
                "answer": "YEN",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0136",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Sounds of wonder at a fireworks show, with \"and aahs\"",
                "answer": "OOHS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not in; \"the lights are ___\"",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Grand musical drama sung on a big stage",
                "answer": "OPERA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Wishes and dreams for the future",
                "answer": "HOPES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Tiptoe up quietly to surprise someone",
                "answer": "SNEAK",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "\"Once ___ a time...\"",
                "answer": "UPON",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cone-shaped tent of the Plains people",
                "answer": "TEPEE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Sounds of hesitation when you can't find a word",
                "answer": "ERS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Hindmost part, the opposite of the front",
                "answer": "REAR",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Poses questions, or requests a favor",
                "answer": "ASKS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0137",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Quiet and motionless, or even now",
                "answer": "STILL",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Break to pieces with a great crash",
                "answer": "SMASH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The steady pace a conductor keeps",
                "answer": "TEMPO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A turn of phrase whose meaning isn't literal",
                "answer": "IDIOM",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bottle of soda holds about one, in metric measure",
                "answer": "LITRE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "One who paints walls in coats, or a tier of cake",
                "answer": "LAYER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Newspapers, radio, and television together",
                "answer": "MEDIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Warm friendship and goodwill between people",
                "answer": "AMITY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Tiny seed-like cell that ferns and mushrooms spread by",
                "answer": "SPORE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Greek poet credited with the Odyssey, or a four-base hit",
                "answer": "HOMER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0138",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Where a letter is sent ___, the sender's line",
                "answer": "FROM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Baked custard with a layer of caramel on top",
                "answer": "FLAN",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Great strictness or harsh exactness",
                "answer": "RIGOR",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small green fruit pressed for its oil",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Roosters and bulls, but not hens and cows",
                "answer": "MALES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Fragrant purple flowering shrub of spring",
                "answer": "LILAC",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Ancient people of Ireland and Scotland",
                "answer": "CELT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Quick and nimble on one's feet",
                "answer": "AGILE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A work of fiction you read for pleasure",
                "answer": "NOVEL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Take a pause to put your feet up",
                "answer": "REST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0139",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Have understanding of a fact",
                "answer": "KNOW",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Gene who tap-danced through Hollywood, or actress Grace",
                "answer": "KELLY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The lowest point of all",
                "answer": "NADIR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Having to do with sheep",
                "answer": "OVINE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Unwanted plant in the garden",
                "answer": "WEED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Go away, or take time off from work",
                "answer": "LEAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The soft lower part of the ear",
                "answer": "LOBE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A beloved tune from years gone by",
                "answer": "OLDIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Unable to see, like the men in the elephant fable",
                "answer": "BLIND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Charlotte Bronte's heroine Jane bears this surname",
                "answer": "EYRE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0140",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Slow ___ steady wins the race\"",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Murky water collecting in the bottom of a ship",
                "answer": "BILGE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse what you've done, or untie",
                "answer": "UNDO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fasten a shoelace in a bow",
                "answer": "TIE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Very small, like a short 1960s skirt",
                "answer": "MINI",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sticky, marshy ground that bogs you down",
                "answer": "MIRE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Squiggly accent mark over the Spanish n",
                "answer": "TILDE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Soft toy bear, or singer Mr. Williams",
                "answer": "TED",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Therefore, in Descartes' famous saying",
                "answer": "ERGO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The fourth letter, spelled out",
                "answer": "DEE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0141",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Place the table before dinner",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Burlap bag for potatoes, or to dismiss from a job",
                "answer": "SACK",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A number divisible by two, or level and smooth",
                "answer": "EVEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Ink powder cartridge for a copier",
                "answer": "TONER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Stay away from, or sidestep",
                "answer": "AVOID",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Small bit of land surrounded by water",
                "answer": "ISLE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Shop that sells cold cuts and sandwiches",
                "answer": "DELI",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Burn fragrant smoke, as in a church service",
                "answer": "CENSE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Mournful sound of a bell tolling slowly",
                "answer": "KNELL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Seattle outdoor-gear co-op, in brief",
                "answer": "REI",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0142",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Arrange in place, like a hen on her eggs",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Greek letter that stands for a total in math",
                "answer": "SIGMA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Precise and accurate to the last detail",
                "answer": "EXACT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Cone-shaped dwelling of the Plains tribes",
                "answer": "TEPEE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Stirred together, like batter for a cake",
                "answer": "MIXED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Actress West known for her witty one-liners",
                "answer": "MAE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The letter after C, spelled out",
                "answer": "DEE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Selfless, loving kindness, an old Greek term",
                "answer": "AGAPE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Host who runs the show and introduces the acts",
                "answer": "EMCEE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0143",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This gift is ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Clenched hands ready for a boxing match",
                "answer": "FISTS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single time, no more",
                "answer": "ONCE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Take a breather and put your feet up",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Hold forth, or share a thought aloud",
                "answer": "OPINE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A strong, lingering smell",
                "answer": "ODOR",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Old printer's type size, or a craving to eat odd things",
                "answer": "PICA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Round records spun on a turntable",
                "answer": "DISCS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Group of eight singers or players",
                "answer": "OCTET",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Egyptian princes' title, in plural",
                "answer": "RAS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0144",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Strongly encourage someone to act",
                "answer": "URGE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put to good ___, make the most of",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A passing of the baton in a track race",
                "answer": "RELAY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Whine and complain about an ache or a fuss",
                "answer": "GRIPE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Chewed up and swallowed",
                "answer": "EATEN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Watery blood fluids used in medicine, plural",
                "answer": "SERA",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The chosen few at the very top",
                "answer": "ELITE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "The letter after R, spelled out",
                "answer": "ESS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Monkeys and gorillas, broadly",
                "answer": "APES",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Longs for, or units of Japanese money",
                "answer": "YENS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0145",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Enjoy, or in the same way as",
                "answer": "LIKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A narrow road, or a marked strip on a highway",
                "answer": "LANE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flawless, just the way it should be",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Loose tunic worn over trousers in India",
                "answer": "KURTA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Tiny helpers in Santa's workshop",
                "answer": "ELVES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A grown person, not a youngster",
                "answer": "ADULT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Canvas shelter you sleep in while camping",
                "answer": "TENT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sheer cheek or daring; \"the ___ of him!\"",
                "answer": "NERVE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Consumed a meal, in the past",
                "answer": "EATEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Final, or to keep going, as shoes might",
                "answer": "LAST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0146",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Coming ___ town, on a return trip",
                "answer": "FROM",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The plant life of a region",
                "answer": "FLORA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flowing water like the Mississippi or Nile",
                "answer": "RIVER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Vast body of salt water, like the Atlantic",
                "answer": "OCEAN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A jumbled, untidy heap on the floor",
                "answer": "MESS",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A thin wedge of cake or pie",
                "answer": "SLICE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Strike down, as a knight does a dragon",
                "answer": "SLAY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cherishes and adores deeply",
                "answer": "LOVES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Open spaces or fields of study",
                "answer": "AREAS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Strand of wool wound into a ball for knitting",
                "answer": "YARN",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0147",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word right before \"end\" or \"top\"",
                "answer": "THE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In that place over yonder",
                "answer": "THERE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Where your brain and your hat both go",
                "answer": "HEAD",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The finish or conclusion of a story",
                "answer": "END",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Back ___, in the old days",
                "answer": "THEN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Flat dish for carrying cups and saucers",
                "answer": "TRAY",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Loaf you slice for sandwiches",
                "answer": "BREAD",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Short, breezy way to say farewell",
                "answer": "BYE",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Fenced patch of grass behind a house",
                "answer": "YARD",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Organ you see with, one of a pair",
                "answer": "EYE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0148",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This bouquet is ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Slowly grow dimmer and disappear",
                "answer": "FADE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished and done ___ with; completely settled",
                "answer": "OVER",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Parts that actors play on stage",
                "answer": "ROLES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Steer clear of, or dodge",
                "answer": "AVOID",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Scratchy feeling that makes you want to rub your skin",
                "answer": "ITCH",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Facts and figures collected for study",
                "answer": "DATA",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Fourth Greek letter, or a river's fan-shaped mouth",
                "answer": "DELTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Stand up straight and tall, or build",
                "answer": "ERECT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Sound a sheep makes, with an h on the end",
                "answer": "SHA",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0149",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This is ___ you,\" said the gift-giver",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One flat side of a cut diamond",
                "answer": "FACET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The ___ one, not this one",
                "answer": "OTHER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Thin and slender, like a tall blade of marsh grass",
                "answer": "REEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Old-fashioned, or stamped with a calendar day",
                "answer": "DATED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Spanish gentleman's title, or a college tutor",
                "answer": "DON",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Without any moisture, like a desert",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Yellowish-brown earthy pigment used by painters",
                "answer": "OCHER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "In want, poor and lacking",
                "answer": "NEEDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Give it a go; \"just ___\"",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0150",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The person being spoken to",
                "answer": "YOU",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not old; fresh and full of life",
                "answer": "YOUNG",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single time, in the past",
                "answer": "ONCE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Not new; a secondhand item",
                "answer": "USED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Famous, admired figures, or small pictures on a screen",
                "answer": "ICONS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small piece of land ringed by water",
                "answer": "ISLE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Adam and Eve's eldest son in the Bible",
                "answer": "CAIN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Gravy or tasty topping for pasta and meat",
                "answer": "SAUCE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Drew a straight mark with a ruler",
                "answer": "LINED",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Language of Britain and America, in brief",
                "answer": "ENG",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0151",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Flying mammals of the night sky",
                "answer": "BATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "'Last ___ not least'",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The inner spirit, in Jung's psychology",
                "answer": "ANIMA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Kitchen gadget that counts down the minutes",
                "answer": "TIMER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Vapor that rises from a boiling kettle",
                "answer": "STEAM",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single one in a measuring system",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Multiplication signs, or 'three ___ four'",
                "answer": "TIMES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Muddy pen where pigs live",
                "answer": "STY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Beef, pork, or chicken at the butcher",
                "answer": "MEAT",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Soldiers serving together as a force",
                "answer": "ARMY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0152",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Over ___, in that spot",
                "answer": "THERE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long lock or braid of hair",
                "answer": "TRESS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A small, miserable dwelling",
                "answer": "HOVEL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rough board for filing fingernails",
                "answer": "EMERY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A whole stretch, from low to high",
                "answer": "RANGE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Step inside a room",
                "answer": "ENTER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Of ancient Italy's great empire",
                "answer": "ROMAN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A happening or special occasion",
                "answer": "EVENT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sturdy twilled fabric used for uniforms",
                "answer": "SERGE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "More cunning or crafty",
                "answer": "SLYER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0153",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Create or produce something",
                "answer": "MAKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Title for an unmarried young lady",
                "answer": "MISS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Protein found in muscle fibers",
                "answer": "ACTIN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Eucalyptus-loving Australian creature",
                "answer": "KOALA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Type your password to ___ the system",
                "answer": "ENTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Famous figures, or images on a screen",
                "answer": "ICONS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Alluring and very attractive",
                "answer": "SEXY",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A condition, or one of the fifty in the union",
                "answer": "STATE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Flintlike quartz, a hard mineral",
                "answer": "SILEX",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Hardly ever, in old-fashioned speech",
                "answer": "NARY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0154",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Toward a lower place",
                "answer": "DOWN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Pointed hat once given for a poor lesson",
                "answer": "DUNCE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pipe instrument heard in church",
                "answer": "ORGAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Legal documents naming who gets the estate",
                "answer": "WILLS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Something you simply must have",
                "answer": "NEED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Madame ___, pioneering scientist who studied radium",
                "answer": "CURIE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The actors in a play",
                "answer": "CAST",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Corner measured in degrees",
                "answer": "ANGLE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Burn the skin with boiling water",
                "answer": "SCALD",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Number after nine",
                "answer": "TENS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0155",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch sight of",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Eighteenth letter of the Greek alphabet",
                "answer": "SIGMA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Sound that bounces back in a canyon",
                "answer": "ECHO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Have a bite of food",
                "answer": "EAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Glittery mineral that flakes into thin sheets",
                "answer": "MICA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Performer who acts without speaking a word",
                "answer": "MIME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "'You ___ be right about that'",
                "answer": "MIGHT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Mothers, affectionately, in some households",
                "answer": "MAS",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Bullets and shells, in soldier's slang",
                "answer": "AMMO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0156",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On the contrary; however",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Rum-soaked little cake",
                "answer": "BABA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pre-owned, like a secondhand car",
                "answer": "USED",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Toss the ball across the yard",
                "answer": "THROW",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "What remains in the fireplace grate",
                "answer": "ASHES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Charlotte Bronte's heroine Jane ___",
                "answer": "EYRE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Winter ride pulled downhill in the snow",
                "answer": "SLED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Pale blue-green gemstone",
                "answer": "BERYL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Love and cherish deeply",
                "answer": "ADORE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Joined in marriage",
                "answer": "WED",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0157",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Small bush in the garden",
                "answer": "SHRUB",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Ahead of the usual time",
                "answer": "EARLY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Express a strong feeling openly",
                "answer": "EMOTE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sense of disgrace or guilt",
                "answer": "SHAME",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Just a moment, briefly",
                "answer": "SEC",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Mistakes, in proofreading shorthand",
                "answer": "ERS",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A mistake or blunder",
                "answer": "ERROR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Groups devoted to unusual beliefs",
                "answer": "CULTS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A casual farewell",
                "answer": "BYE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0158",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work or make ___ of",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Workers' organized labor group",
                "answer": "UNION",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Right away, in a doctor's order",
                "answer": "STAT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Every single one",
                "answer": "EACH",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Diamond-shaped ray that glides through the ocean",
                "answer": "MANTA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hazy fog over the meadow",
                "answer": "MIST",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Soothing plant whose gel calms burns",
                "answer": "ALOE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Relating to the pelvic bone",
                "answer": "ILIAC",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Predict, in old-fashioned speech",
                "answer": "SOOTH",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "One less than eleven",
                "answer": "TEN",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0159",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Baseball calls when a batter is retired",
                "answer": "OUTS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The opposite of in",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Join together as one",
                "answer": "UNITE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Kept track of, as a race's seconds",
                "answer": "TIMED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "In ___ of, as a substitute for",
                "answer": "STEAD",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single member of a set",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Repeated occasions, or the newspaper of record",
                "answer": "TIMES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Home for hogs",
                "answer": "STY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Soft fleshy part of a cow's udder",
                "answer": "TEAT",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Whirling little current of water",
                "answer": "EDDY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0160",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'___ were the days,' said wistfully",
                "answer": "THOSE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A pang of deep anguish",
                "answer": "THROE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Makes well again, as time does wounds",
                "answer": "HEALS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Path a planet takes around the sun",
                "answer": "ORBIT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Smooth Italian white wine",
                "answer": "SOAVE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Come into a hall, say",
                "answer": "ENTER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Long-legged wading bird at the marsh",
                "answer": "HERON",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Capital city of Morocco",
                "answer": "RABAT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Small green or black fruit on a relish tray",
                "answer": "OLIVE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Sweet-smelling compound from acid and alcohol",
                "answer": "ESTER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0161",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'What is ___?' asked while pointing",
                "answer": "THIS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "What the spring sun does to winter snow",
                "answer": "THAW",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Busy bee colonies in wooden boxes",
                "answer": "HIVES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Perfect example of a flawless sort",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Wait on guests at the dinner table",
                "answer": "SERVE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Conceals from view",
                "answer": "HIDES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Hearty pot of slowly simmered meat and vegetables",
                "answer": "STEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Turn away, as one might a disaster",
                "answer": "AVERT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Make a basket on a loom",
                "answer": "WEAVE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A great many, casually speaking",
                "answer": "SLEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0162",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "V",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Numbers like two, four, and six",
                "answer": "EVEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wears away slowly, as water does rock",
                "answer": "ERODE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Grand country house with a garden",
                "answer": "VILLA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fragrant compound used in flavorings",
                "answer": "ESTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Close by, not far off",
                "answer": "NEAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Get up from a chair",
                "answer": "ARISE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Keen and eager, as a reader",
                "answer": "AVID",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "River through Switzerland's Aosta valley",
                "answer": "VOLTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Person who would rather not work",
                "answer": "IDLER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Beloved one, or a letter's greeting",
                "answer": "DEAR",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0163",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make ___ of, put to a purpose",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Togetherness and harmony among people",
                "answer": "UNITY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Boys to their mothers",
                "answer": "SONS",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A bit of cuddly affection, casually",
                "answer": "SNOG",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Close, as a door at night",
                "answer": "SHUT",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Tan cotton trousers",
                "answer": "CHINO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Lettuce in a Caesar salad, briefly",
                "answer": "COS",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Baseball plays that retire the batter",
                "answer": "OUTS",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Pen where the pigs are kept",
                "answer": "STY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0164",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'This gift is ___ you'",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Level and even, like a tabletop",
                "answer": "FLAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Greasy to the touch",
                "answer": "OILY",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Knot a shoelace again",
                "answer": "RETIE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A loyal lord in feudal times",
                "answer": "LIEGE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A group of thugs, or a road crew",
                "answer": "GANG",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Therefore, in a logical argument",
                "answer": "ERGO",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Table at the front of a church",
                "answer": "ALTAR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Knotting up, as a shoelace",
                "answer": "TYING",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0165",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Group of matching dishes, or a tennis division",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Reddish-brown tone of an old photograph",
                "answer": "SEPIA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A notable happening on the calendar",
                "answer": "EVENT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rich chocolate dessert, often flourless",
                "answer": "TORTE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "County in southwest England known for cream teas",
                "answer": "DEVON",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "'Old ___,' a wise senior figure, slangily",
                "answer": "DOM",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Old-fashioned word for no",
                "answer": "NAY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A grand musical drama, sung throughout",
                "answer": "OPERA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Having a fresh peppermint flavor",
                "answer": "MINTY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0166",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'On your mark, get ___, go!'",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "An overbearing, prejudiced person",
                "answer": "BIGOT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single item in a measuring scale",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rise and fall of the ocean at the shore",
                "answer": "TIDE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Thin Russian buckwheat pancake",
                "answer": "BLINI",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Raised, as a child or livestock",
                "answer": "BRED",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Long, fancy chauffeured car, for short",
                "answer": "LIMO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Firm and stiff, not flexible",
                "answer": "RIGID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Show feeling deeply",
                "answer": "EMOTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Tiny spot on the page",
                "answer": "DOT",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0167",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Capable and ready to do something",
                "answer": "ABLE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Take action; a stage performance",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Loud blasts, as of a cannon",
                "answer": "BOOMS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Open Hawaiian porch or veranda",
                "answer": "LANAI",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Precise and accurate, down to the detail",
                "answer": "EXACT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Gently persuade or wheedle",
                "answer": "COAX",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Having to do with musical pitch",
                "answer": "TONAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Sheltered side, away from the wind",
                "answer": "LEE",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Heavy club, or a spray for self-defense",
                "answer": "MACE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A spot or location for a building",
                "answer": "SITE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0168",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'May I ___ this dance?'",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A hearty laugh on the page",
                "answer": "HAHA",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Clock that wakes you in the morning",
                "answer": "ALARM",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The brink or edge of something",
                "answer": "VERGE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A mistake on a test",
                "answer": "ERROR",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "On watch and ready, or a warning signal",
                "answer": "ALERT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "River through Newcastle, England",
                "answer": "TYNE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bother or pester repeatedly",
                "answer": "HARRY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Gas that fills glowing colored signs",
                "answer": "ARGON",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Nothing more than; just",
                "answer": "MERE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0169",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'I knew ___ all along'",
                "answer": "THAT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Honestly; in fact",
                "answer": "TRULY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A person; one of mankind",
                "answer": "HUMAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Love and admire greatly",
                "answer": "ADORE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A word, or the length of a school semester",
                "answer": "TERM",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Raw and unrefined, like a barrel of oil",
                "answer": "CRUDE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A friendly little conversation",
                "answer": "CHAT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Wit and good-natured fun",
                "answer": "HUMOR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A loud bell or signal of danger",
                "answer": "ALARM",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "English river meeting the North Sea at Newcastle",
                "answer": "TYNE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0170",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a peek",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word said with a sincere apology",
                "answer": "SORRY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Wicked and bad",
                "answer": "EVIL",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Have your dinner",
                "answer": "EAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A brilliant new star in the sky",
                "answer": "NOVA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Close in distance",
                "answer": "NEAR",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Worthiness deserving of reward",
                "answer": "MERIT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Trained nurse, for short",
                "answer": "MED",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "British nobleman ranking below a marquess",
                "answer": "EARL",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Without any moisture",
                "answer": "DRY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0171",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Chimpanzees and gorillas, for example",
                "answer": "APES",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Number of innings in a baseball game",
                "answer": "NINE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Mischievous imp with horns and a pitchfork",
                "answer": "DEVIL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A slice of cake, or a single part of a set",
                "answer": "PIECE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Pointed shape of an ice cream holder",
                "answer": "CONE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Watched closely, or had peepers",
                "answer": "EYED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A diplomat sent to represent a nation",
                "answer": "ENVOY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fishing net, or a river through Paris",
                "answer": "SEINE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Guided the way, in the past tense",
                "answer": "LED",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0172",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Three cheers ___ the winner!'",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One small flat surface of a cut diamond",
                "answer": "FACET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The ___ side of the coin",
                "answer": "OTHER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Marshy and thick with tall grasses",
                "answer": "REEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Marked with a year, as an old letter",
                "answer": "DATED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Plural of do, in old usage",
                "answer": "DOS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Not the least bit wet",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Yellowish-brown earthy pigment",
                "answer": "OCHER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Full of small seeds, like a ripe fig",
                "answer": "SEEDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Give it a go",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0173",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In favor of, as a vote ___ a plan",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Shapes or molds something",
                "answer": "FORMS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "One time, in a fairy-tale opening",
                "answer": "ONCE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Enjoy a good book",
                "answer": "READ",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A pebble or a precious gem",
                "answer": "STONE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Mark left on the skin after a wound heals",
                "answer": "SCAR",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Grow weary; a wheel's rubber ring",
                "answer": "TIRE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "About or around, with a date",
                "answer": "CIRCA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Carrying a weapon",
                "answer": "ARMED",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Latin for 'thing,' seen in legal phrases",
                "answer": "RES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0174",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Soft rolls split for hamburgers",
                "answer": "BUNS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "'Slow ___ steady wins the race'",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Single pieces that make up a whole",
                "answer": "UNITS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Explosive liquid, glycerine compound for short",
                "answer": "NITRO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Cloud rising from a simmering pot",
                "answer": "STEAM",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "One measure on a ruler",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Strength of a solution, in a lab test",
                "answer": "TITER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Grain used in dark bread and whiskey",
                "answer": "RYE",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Flat platter for carrying the tea things",
                "answer": "TRAY",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A certain amount, not all",
                "answer": "SOME",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0175",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'___ way did he go?'",
                "answer": "WHICH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Old British political party opposing the Tories",
                "answer": "WHIGS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Many-headed serpent of Greek myth",
                "answer": "HYDRA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Just perfect; a goal to strive for",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Skill at making things by hand",
                "answer": "CRAFT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Welcomes guests into the home",
                "answer": "HOSTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Electric power, for short",
                "answer": "HYDRO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bright thoughts that come to mind",
                "answer": "IDEAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "To attach a plant cutting onto another",
                "answer": "GRAFT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Seasonings shaken on at the table, with peppers",
                "answer": "SALTS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0176",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Pleasant and well-behaved",
                "answer": "GOOD",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Prod or urge on, like a stubborn mule",
                "answer": "GOAD",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The holder of the deed to a house",
                "answer": "OWNER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small green fruit pressed for oil",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "An evil spirit or fiend",
                "answer": "DEMON",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Baby member of a hooting nighttime bird family",
                "answer": "OWLET",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Canvas shelter for a camping trip",
                "answer": "TENT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Japanese style of animated cartoon",
                "answer": "ANIME",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "English county whose cream is famous",
                "answer": "DEVON",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Monthly payment to a landlord",
                "answer": "RENT",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0177",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Additional, beyond what's there",
                "answer": "MORE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Affectionate name for grandmother in some homes",
                "answer": "MAMMA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Layered bulb that brings tears when you chop it",
                "answer": "ONION",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Dangers or gambles one takes",
                "answer": "RISKS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Simple, not difficult at all",
                "answer": "EASY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A wild craze or obsession",
                "answer": "MANIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A great heap or pile of stuff",
                "answer": "MASS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Not on target, as a missed shot",
                "answer": "AMISS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wreathed in a campfire's gray haze",
                "answer": "SMOKY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Without, in fancy French-flavored English",
                "answer": "SANS",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0178",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Down and ___, completely beaten",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Green refuge in the middle of a desert",
                "answer": "OASIS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting atop, as a book on a shelf",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Cat's nickname, or Mark Twain's Sawyer",
                "answer": "TOM",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Fret marker that raises a guitar's pitch",
                "answer": "CAPO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Black rock dug from the mine for fuel",
                "answer": "COAL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The heart of one's being; close friend, with 'buddy'",
                "answer": "BOSOM",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Undergarment for the upper body",
                "answer": "BRA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Wet weather falling from the clouds",
                "answer": "RAIN",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Possessive of a man's name, like 'that's ___'",
                "answer": "ALS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0179",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Once and ___ all'",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Heads-up shout on the golf course",
                "answer": "FORE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Unlocked, like an unbarred gate",
                "answer": "OPEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Tears in fabric, or what tenants pay",
                "answer": "RENTS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A grand stage drama set to music",
                "answer": "OPERA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Spinning spool that holds the fishing line",
                "answer": "REEL",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Crooked or off to one side",
                "answer": "AWRY",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Make fresh again, as a subscription",
                "answer": "RENEW",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Go in through the doorway",
                "answer": "ENTER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Cunning and crafty",
                "answer": "SLY",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0180",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Whether or ___'",
                "answer": "NOT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Crisp tortilla chip with cheese",
                "answer": "NACHO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Many times; frequently",
                "answer": "OFTEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rows of seats rising in a stadium",
                "answer": "TIERS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Secretive organized-crime ring",
                "answer": "MAFIA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A clever, witty remark, in old usage",
                "answer": "MOT",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Past tense of eat",
                "answer": "ATE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A group of eight musicians",
                "answer": "OCTET",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Over ___, in that place",
                "answer": "THERE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Light switch settings opposite of offs",
                "answer": "ONS",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0181",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However; on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Shaggy giant of the American plains",
                "answer": "BISON",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single item or member of a group",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The quality of a musical sound",
                "answer": "TONE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Type of acid that builds proteins in the body",
                "answer": "AMINO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Greek god of war",
                "answer": "ARES",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Brief written note in the office",
                "answer": "MEMO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sticky substance that oozes from pine trees",
                "answer": "RESIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Show feeling on stage with great drama",
                "answer": "EMOTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A man's male child",
                "answer": "SON",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0182",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Grain used to make porridge",
                "answer": "OATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not at home; away",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Style of Japanese cartoon",
                "answer": "ANIME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Having to do with the rise and fall of the sea",
                "answer": "TIDAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Editor's marks meaning 'let it stand'",
                "answer": "STETS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single measure, such as a foot or a meter",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Got through hard times, as one 'over' a rough spell",
                "answer": "TIDED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Fourth letter of the alphabet, spelled out",
                "answer": "DEE",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Close companion or chess move shout",
                "answer": "MATE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Otherwise; if not",
                "answer": "ELSE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0183",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Feeling cheerful and content",
                "answer": "HAPPY",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Tall peaks, or moments of great joy",
                "answer": "HIGHS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Little plastic tip at the end of a shoelace",
                "answer": "AGLET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Flying machine with wings and engines",
                "answer": "PLANE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "To strut or show off, in British slang",
                "answer": "PONCE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sing in the Swiss mountain style, with leaps in pitch",
                "answer": "YODEL",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Dome-shaped snow house of the Arctic",
                "answer": "IGLOO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Body part that produces hormones or sweat",
                "answer": "GLAND",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Therefore; from this reason",
                "answer": "HENCE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Strong metal made from iron and carbon",
                "answer": "STEEL",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0184",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "To possess or own",
                "answer": "HAVE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Old-fashioned form of 'has'",
                "answer": "HATH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Relating to birds",
                "answer": "AVIAN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Device that controls the flow through a pipe",
                "answer": "VALVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sea duck prized for its soft down feathers",
                "answer": "EIDER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "To be of use or help",
                "answer": "AVAIL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Loan something to a friend",
                "answer": "LEND",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wavy mark above the n in some Spanish words",
                "answer": "TILDE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A safe and peaceful place of shelter",
                "answer": "HAVEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Brainy sort who loves facts and study",
                "answer": "NERD",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0185",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Require; must have",
                "answer": "NEED",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Unwanted loud sound",
                "answer": "NOISE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Rub out, as pencil marks",
                "answer": "ERASE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Tall white wading bird of the marshes",
                "answer": "EGRET",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Put down with an insult, in slang",
                "answer": "DISS",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Short-legged herding dog favored by the Queen",
                "answer": "CORGI",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Shellfish that can hold a pearl",
                "answer": "CLAM",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Folks who do not tell the truth",
                "answer": "LIARS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Stubborn donkeys",
                "answer": "ASSES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Come together face to face",
                "answer": "MEET",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0186",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A play is divided into one of these",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Cars, in casual speech",
                "answer": "AUTOS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Shellfish that walks sideways on the beach",
                "answer": "CRAB",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Number after nine",
                "answer": "TEN",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Confident and certain",
                "answer": "SURE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Tall tower for storing grain on a farm",
                "answer": "SILO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Mighty giant of Greek myth",
                "answer": "TITAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sound of mild disapproval, 'tut-tut'",
                "answer": "TSK",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A messy, sloppy person",
                "answer": "SLOB",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Old units of distance in India, two miles each",
                "answer": "KOS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0187",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word joining two opposing ideas",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Worm on the hook to lure a fish",
                "answer": "BAIT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Unfasten, as a knot or button",
                "answer": "UNDO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rows of seats rising up in a stadium",
                "answer": "TIERS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The inner soul or spirit, in psychology",
                "answer": "ANIMA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Partner or close friend, in Aussie slang",
                "answer": "MATE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Wise guy known for a 'smart' remark",
                "answer": "ALEC",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Perfect example to aim for",
                "answer": "IDEAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Rich, layered cake for a special occasion",
                "answer": "TORTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Just a moment, briefly",
                "answer": "SEC",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0188",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "No longer in fashion, like a worn-'___' style",
                "answer": "OUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Small green fruit often stuffed into a martini",
                "answer": "OLIVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Speak words aloud",
                "answer": "UTTER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small colorful fish for a home aquarium",
                "answer": "TETRA",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Change or adjust, as a garment",
                "answer": "ALTER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Fuss or commotion over nothing",
                "answer": "ADO",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Spoil or decay, as old fruit",
                "answer": "ROT",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Exactly the same, as in a repeated entry",
                "answer": "DITTO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Out in the open; not hidden",
                "answer": "OVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0189",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Still; nevertheless",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Narrow-minded, intolerant person",
                "answer": "BIGOT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single complete part of a whole",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The daily rise and fall of ocean water",
                "answer": "TIDE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Thin Russian pancakes served with caviar",
                "answer": "BLINI",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Make coffee or tea by steeping",
                "answer": "BREW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Green citrus fruit, smaller than a lemon",
                "answer": "LIME",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Stiff and unbending",
                "answer": "RIGID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Express feelings dramatically",
                "answer": "EMOTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Soaked through with water",
                "answer": "WET",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0190",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Gentle taps on the head, playfully",
                "answer": "BOPS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word that introduces an exception",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Milky gemstones that shimmer with color",
                "answer": "OPALS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small water creature with stinging tentacles",
                "answer": "POLYP",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Noisy breathing during sleep",
                "answer": "SNORE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Resting atop something",
                "answer": "UPON",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sharp claw of a hawk or eagle",
                "answer": "TALON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Just made or recently arrived",
                "answer": "NEW",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Small harp once plucked by ancient Greeks",
                "answer": "LYRE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Pour out forcefully, as words or lava",
                "answer": "SPEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0191",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Accompanied by; alongside",
                "answer": "WITH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Pay earned for a week's work",
                "answer": "WAGE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Just perfect; the best possible",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A faint trace of color or feeling",
                "answer": "TINGE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Backs of the feet",
                "answer": "HEELS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A fond farewell, French-style",
                "answer": "ADIEU",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Puts to work, as a tool",
                "answer": "USES",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Tiny units of heredity passed from parents",
                "answer": "GENES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Majestic bird and symbol of America",
                "answer": "EAGLE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Not as much",
                "answer": "LESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0192",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Where you have ___ all your life",
                "answer": "BEEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Showing courage in the face of danger",
                "answer": "BRAVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished a meal",
                "answer": "EATEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Each and all, without exception",
                "answer": "EVERY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The one coming right after this",
                "answer": "NEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Serious and solemn in manner",
                "answer": "GRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Pleased and happy",
                "answer": "GLAD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Stretchy material used to make gloves",
                "answer": "LATEX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Turn away to prevent, as trouble",
                "answer": "AVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Say no; refuse to admit",
                "answer": "DENY",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0193",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Most common word in English, before a noun",
                "answer": "THE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A faint mark or small sign left behind",
                "answer": "TRACE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "To hold or possess",
                "answer": "HAVE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Pull along the ground",
                "answer": "DRAG",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Make a picture with pencil and paper",
                "answer": "DRAW",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Cheer of approval after a fine performance",
                "answer": "BRAVO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A woman's undergarment",
                "answer": "BRA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A contest of speed",
                "answer": "RACE",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wonder mixed with respect",
                "answer": "AWE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0194",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Except; on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Money paid to get out of jail",
                "answer": "BAIL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse or cancel an action",
                "answer": "UNDO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Levels of a wedding cake, stacked up",
                "answer": "TIERS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Japanese animated film style",
                "answer": "ANIME",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Created or produced",
                "answer": "MADE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "If not; otherwise",
                "answer": "ELSE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Just right; perfect",
                "answer": "IDEAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Noble title holders in Britain",
                "answer": "LORDS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Use your eyes to look",
                "answer": "SEE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0195",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of; in favor of",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One small side or surface of a cut gem",
                "answer": "FACET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The remaining one; not this but the ___",
                "answer": "OTHER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Thin and slender, like a marsh plant's stem",
                "answer": "REEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Strongly disliked",
                "answer": "HATED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Affectionate name for a sweetheart",
                "answer": "HON",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Free of moisture",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Yellowish-brown earthy paint pigment",
                "answer": "OCHER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "In great want; poor",
                "answer": "NEEDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Make an attempt",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0196",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Belonging to him",
                "answer": "HIS",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Building where a family lives",
                "answer": "HOUSE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A bright thought or plan",
                "answer": "IDEA",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Offer goods for money",
                "answer": "SELL",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The place where one lives; a dwelling",
                "answer": "ABODE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Pimples on the skin, often in youth",
                "answer": "ACNE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The loud call of a donkey",
                "answer": "BRAY",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Deliberately unkind or harsh",
                "answer": "CRUEL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Spoken through the nose, like a stuffy voice",
                "answer": "NASAL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The organ you see with",
                "answer": "EYE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0197",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Roast meat slowly on a long rod over a fire",
                "answer": "SPIT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Place down, as the table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Heartfelt requests or appeals",
                "answer": "PLEAS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A matter or topic up for discussion",
                "answer": "ISSUE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small colorful fish kept in a tank",
                "answer": "TETRA",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "In addition; other than that",
                "answer": "ELSE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "School exams",
                "answer": "TESTS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Took a seat",
                "answer": "SAT",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A glow or feeling that surrounds a person",
                "answer": "AURA",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A chair, or the place reserved for you",
                "answer": "SEAT",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0198",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The smallest amount",
                "answer": "LEAST",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Comic Jerry of variety-show fame, or Carroll's surname",
                "answer": "LEWIS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "To be real; to live",
                "answer": "EXIST",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Walkway between rows of theater seats",
                "answer": "AISLE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Drift off for the night",
                "answer": "SLEEP",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Trials and exams",
                "answer": "TESTS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Banish someone from their homeland",
                "answer": "EXILE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Grows more clever or shrewd",
                "answer": "WISES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A very small island",
                "answer": "ISLET",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Stairs taken one at a time",
                "answer": "STEPS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0199",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Starting at; out of",
                "answer": "FROM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Federal agents, in slang",
                "answer": "FEDS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Crumbling remains of an old building",
                "answer": "RUINS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Pipe instrument found in many churches",
                "answer": "ORGAN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The Fates' name in Greek myth, or a girl's name",
                "answer": "MOIRA",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Continental coins replacing the franc and lira",
                "answer": "EUROS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A single stair, or a move forward on foot",
                "answer": "STEP",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A single numeral, 0 through 9",
                "answer": "DIGIT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Trap for catching small animals",
                "answer": "SNARE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A quick breaking sound of the fingers",
                "answer": "SNAP",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0200",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "At that time; afterward",
                "answer": "THEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The main subject or topic of a story",
                "answer": "THEME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A small, shabby, run-down dwelling",
                "answer": "HOVEL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A happening or occasion",
                "answer": "EVENT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Require; have to have",
                "answer": "NEED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Push roughly with both hands",
                "answer": "SHOVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Killed in great numbers, in old usage",
                "answer": "SLEW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Earthen bank built to hold back a river",
                "answer": "LEVEE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Correct the text of a document",
                "answer": "EMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Raised ridge on the skin from a blow",
                "answer": "WELT",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0201",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work; make good of",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Ordinary; what normally happens",
                "answer": "USUAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Without, in French",
                "answer": "SANS",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Russian emperor of old",
                "answer": "TSAR",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A story told to children at bedtime",
                "answer": "TALE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Hot steam room of Finnish origin",
                "answer": "SAUNA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Feeling low or blue",
                "answer": "SAD",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cry of dismay or sorrow",
                "answer": "ALAS",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Computer key for removing, briefly",
                "answer": "DEL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0202",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The person being spoken to",
                "answer": "YOU",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Open space behind a house, often with grass",
                "answer": "YARD",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Large shiny ocean fish, also called moonfish",
                "answer": "OPAH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Upward stroke of a violinist's bow",
                "answer": "UPBOW",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Round fruit said to keep the doctor away",
                "answer": "APPLE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Low-calorie, as some soft drinks (informal spelling)",
                "answer": "LITE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Correct mistakes in writing",
                "answer": "EDIT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Foaming at the mouth; furious",
                "answer": "RABID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Cloth wrapped as a garment in India",
                "answer": "DHOTI",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Damp from rain",
                "answer": "WET",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0203",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take steps; do something",
                "answer": "ACT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Crisp red or green fruit from an orchard",
                "answer": "APPLE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "An accepted rule or standard of judgment",
                "answer": "CANON",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Step heavily; the grooved surface of a tire",
                "answer": "TREAD",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Extra; kept in reserve",
                "answer": "SPARE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Droop or sink in the middle",
                "answer": "SAG",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Take in food at the table",
                "answer": "EAT",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A pause in breathing during sleep",
                "answer": "APNEA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Take smug pleasure in another's loss",
                "answer": "GLOAT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The finish or close",
                "answer": "END",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0204",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make practical of; employ",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Workers' group that bargains together",
                "answer": "UNION",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Fine grains covering the beach",
                "answer": "SAND",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "If not; otherwise",
                "answer": "ELSE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Dull and ordinary, lacking originality",
                "answer": "BANAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Make a fresh pot of coffee",
                "answer": "BREW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Prefix meaning 'air,' as in airplane terms",
                "answer": "AERO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Straps used to guide a horse",
                "answer": "REINS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wear away, as rock by water",
                "answer": "ERODE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Came out on top; was victorious",
                "answer": "WON",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0205",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Government agents, in slang",
                "answer": "FEDS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In support of; meant to be given to",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Slim swords used in fencing",
                "answer": "EPEES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A performer's very first public appearance",
                "answer": "DEBUT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A trap with a loop to catch an animal",
                "answer": "SNARE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Not shut",
                "answer": "OPEN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Steel rod that strengthens concrete",
                "answer": "REBAR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Coins spent in France, Germany, and Italy today",
                "answer": "EURO",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Hearty dish simmered slowly in a pot",
                "answer": "STEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0206",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Small timepiece worn on the wrist",
                "answer": "WATCH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Strolls; goes on foot",
                "answer": "WALKS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Deep and lasting pain or distress",
                "answer": "AGONY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Soft cloth for drying after a bath",
                "answer": "TOWEL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Move slowly and quietly, low to the ground",
                "answer": "CREEP",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rough and unkind in tone",
                "answer": "HARSH",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Open marketplace of ancient Greece",
                "answer": "AGORA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bring down to a smaller amount",
                "answer": "LOWER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Joints in the middle of your legs",
                "answer": "KNEES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A slender, graceful air spirit of folklore",
                "answer": "SYLPH",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0207",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Past-tense form used with 'we' or 'they'",
                "answer": "WERE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Broad from side to side",
                "answer": "WIDE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Makes changes to a manuscript",
                "answer": "EDITS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A playful scoundrel up to mischief",
                "answer": "ROGUE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Leave out a sound when speaking quickly",
                "answer": "ELIDE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Famous figures fans adore",
                "answer": "IDOLS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A single stair, or a stride forward",
                "answer": "STEP",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A single numeral from 0 to 9",
                "answer": "DIGIT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A practice piece for the piano",
                "answer": "ETUDE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Trickle in slowly through a crack",
                "answer": "SEEP",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0208",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Have the facts in your head",
                "answer": "KNOW",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Hollywood legend Grace, later a princess",
                "answer": "KELLY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The lowest point of fortune",
                "answer": "NADIR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Relating to sheep",
                "answer": "OVINE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Seven days in a row",
                "answer": "WEEK",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Go away; depart",
                "answer": "LEAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Soft fleshy bottom part of the ear",
                "answer": "LOBE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A beloved old song from years past",
                "answer": "OLDIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Shut and open the eyes quickly",
                "answer": "BLINK",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Charlotte Bronte's heroine, Jane ___",
                "answer": "EYRE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0209",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good purpose",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "More than is fair or proper",
                "answer": "UNDUE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A sulky, bad-tempered mood",
                "answer": "SNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Have a bite of food",
                "answer": "EAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Tolstoy heroine ___ Karenina",
                "answer": "ANNA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Old, as in 'for ___ lang syne'",
                "answer": "AULD",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Careful check of the financial books",
                "answer": "AUDIT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "In times past; previously",
                "answer": "AGO",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Eat far too much",
                "answer": "GLUT",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A poem of praise",
                "answer": "ODE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0210",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take in with the eyes",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Cries with heaving breaths",
                "answer": "SOBS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A number divisible by two; or smooth and level",
                "answer": "EVEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Having handles, as a jug, or able to hear",
                "answer": "EARED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Egg-shaped",
                "answer": "OVATE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Tall plant with a trunk, branches, and leaves",
                "answer": "TREE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Charlotte Bronte's Jane ___",
                "answer": "EYRE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Small round fruit; a currant or grape, for example",
                "answer": "BERRY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Curl the lip in scorn",
                "answer": "SNEER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Letter between C and E, written out",
                "answer": "DEE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0211",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Place the plates and forks on the table",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Brownish tone of old photographs",
                "answer": "SEPIA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "To be alive and real",
                "answer": "EXIST",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "On edge and jittery",
                "answer": "TENSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sorted by male or female",
                "answer": "SEXED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Famous call for help in Morse code",
                "answer": "SOS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Comedian and actress Susan ___ of '227'",
                "answer": "DEY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Share what you think about something",
                "answer": "OPINE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Old-fashioned word for a timid soul",
                "answer": "SISSY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0212",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word meaning 'however'",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sturdy tree branch",
                "answer": "BOUGH",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Strong inner push to do something",
                "answer": "URGE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Little pegs golfers set the ball on",
                "answer": "TEES",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Love and cherish deeply",
                "answer": "ADORE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Like a fine wine that has matured",
                "answer": "AGED",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Early art movement led by Marcel Duchamp",
                "answer": "DADA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Measure the amount of something",
                "answer": "GAUGE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Borders or rims of a tabletop",
                "answer": "EDGES",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The long sound in Morse code",
                "answer": "DAH",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0213",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Mighty trees that grow from acorns",
                "answer": "OAKS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "No longer in, but ___",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "In psychology, the feminine side of the mind",
                "answer": "ANIMA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Toys that fly on a string in the breeze",
                "answer": "KITES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hidden store of money or supplies",
                "answer": "STASH",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single one of something",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A giant of enormous strength",
                "answer": "TITAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "A flat refusal",
                "answer": "NAY",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Flat-topped hill of the Southwest",
                "answer": "MESA",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Pale gray, like cold embers",
                "answer": "ASHY",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0214",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Where there's a ___, there's a way'",
                "answer": "WILL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Make a quiet hope when blowing out candles",
                "answer": "WISH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Fresh thoughts and bright notions",
                "answer": "IDEAS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Slangy word for completely real and proper",
                "answer": "LEGIT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Woman's name that means 'laurel'",
                "answer": "LAURA",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Perfect or just right",
                "answer": "IDEAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Word meaning 'for fear that'",
                "answer": "LEST",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Smooth move from one song to the next",
                "answer": "SEGUE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Strands on your head",
                "answer": "HAIRS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Right away, in a hospital",
                "answer": "STAT",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0215",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Where have you ___?'",
                "answer": "BEEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bold and fearless",
                "answer": "BRAVE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished off the whole plate",
                "answer": "EATEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Each and all, without exception",
                "answer": "EVERY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The one coming after this",
                "answer": "NEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Long for something badly",
                "answer": "CRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Dressed or covered, as in armor",
                "answer": "CLAD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Stretchy material for gloves and balloons",
                "answer": "LATEX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Turn aside or prevent, as disaster",
                "answer": "AVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Flatly refuse to admit",
                "answer": "DENY",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0216",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take in with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Place to get your hair done",
                "answer": "SALON",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Give off, as light or heat",
                "answer": "EMIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The finish or close of something",
                "answer": "END",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Confound it!",
                "answer": "DAMN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Finished and over with",
                "answer": "DONE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Firm and not hollow",
                "answer": "SOLID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The blue above us on a clear day",
                "answer": "SKY",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Tie in a rope or shoelace",
                "answer": "KNOT",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A strong longing or urge",
                "answer": "YEN",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0217",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look and judge for yourself",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Tuck away neatly for travel",
                "answer": "STOW",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Every single one",
                "answer": "EACH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Do really well at something",
                "answer": "EXCEL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Charged extra money to, by the government",
                "answer": "TAXED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Common money of France, Italy, and Spain today",
                "answer": "EURO",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Sketched with a pencil",
                "answer": "DREW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Happen or take place",
                "answer": "OCCUR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Question word asking about a place",
                "answer": "WHERE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Opposite of high",
                "answer": "LOW",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0218",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Just made or recently bought",
                "answer": "NEW",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Well known and respected for something",
                "answer": "NOTED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Something more, beyond the usual",
                "answer": "EXTRA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Full of unwanted garden plants",
                "answer": "WEEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Wrapped up, as a present",
                "answer": "BOXED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Roll-up hairstyle worn at the back",
                "answer": "BUN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Without any moisture",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Say out loud",
                "answer": "UTTER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bookish sort, fond of facts and figures",
                "answer": "NERDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0219",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'This bouquet is ___ you'",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Causing death, as a wound",
                "answer": "FATAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished and done with",
                "answer": "OVER",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Take a breather",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bold and fearless",
                "answer": "BRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Boast or show off",
                "answer": "BRAG",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Ready to be picked, as fruit",
                "answer": "RIPE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Solemn ceremonies, like a wedding's",
                "answer": "RITES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Separated from one another",
                "answer": "APART",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Hair styling goo",
                "answer": "GEL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0220",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A wide, bright smile",
                "answer": "BEAM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "'Last ___ not least'",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A slip or mistake",
                "answer": "ERROR",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Nimble and quick on your feet",
                "answer": "AGILE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Breakfast, lunch, and dinner",
                "answer": "MEALS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A strong push to act",
                "answer": "URGE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A test run before the real thing",
                "answer": "TRIAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Short word for a back muscle",
                "answer": "LAT",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "An earthenware pot for cooking",
                "answer": "OLLA",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Take a load off and relax",
                "answer": "REST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0221",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'I don't know ___ way to go'",
                "answer": "WHICH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put down on paper, in the past",
                "answer": "WROTE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Wishes and dreams for the future",
                "answer": "HOPES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Plans and bright notions",
                "answer": "IDEAS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Perfume the air with fragrant smoke, as a priest might",
                "answer": "CENSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rubber tubes for watering the garden",
                "answer": "HOSES",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cowboy show with bucking broncos",
                "answer": "RODEO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Unlocks a door",
                "answer": "OPENS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Gently poke fun at a friend",
                "answer": "TEASE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The letter S, written out, more than once",
                "answer": "ESSES",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0222",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Take ___ to the kitchen'",
                "answer": "THIS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word for those people",
                "answer": "THEM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Brought on for a wage",
                "answer": "HIRED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Smooth white material from elephant tusks",
                "answer": "IVORY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Grassy plant found along marshy banks",
                "answer": "SEDGE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Bumps on the skin from a bee sting",
                "answer": "HIVES",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What you plant to grow a flower",
                "answer": "SEED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Wear away slowly, as a riverbank",
                "answer": "ERODE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Join together into one",
                "answer": "MERGE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Colored with a tint, as Easter eggs",
                "answer": "DYED",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0223",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The greatest amount",
                "answer": "MOST",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Very tiny, with a prefix",
                "answer": "MICRO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Many times over, repeatedly",
                "answer": "OFTEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Stalk of a mushroom",
                "answer": "STIPE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "River that flows past Newcastle, England",
                "answer": "TYNE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Half of one hundred",
                "answer": "FIFTY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A point that is plainly true",
                "answer": "FACT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Protein found in muscle tissue",
                "answer": "ACTIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Thin French pancake",
                "answer": "CREPE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The pitch or sound of a voice",
                "answer": "TONE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0224",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "One part of a stage play",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "An orderly lineup of items",
                "answer": "ARRAY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Adam and Eve's eldest son",
                "answer": "CAIN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A pair, in number",
                "answer": "TWO",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sketch with a pencil",
                "answer": "DRAW",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Lacking shine or sparkle",
                "answer": "DULL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "An interesting little keepsake or trinket",
                "answer": "CURIO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cover for the head with a brim",
                "answer": "CAP",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Mr. Alda of 'M*A*S*H'",
                "answer": "ALAN",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Layer of a folded sheet",
                "answer": "PLY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0225",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Adjust the clock to the right time",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A small mark or stain",
                "answer": "SPOT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Every single one, individually",
                "answer": "EACH",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Walk heavily, step by step",
                "answer": "TREAD",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Hooded winter coat",
                "answer": "PARKA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Citizen ___, the famous Orson Welles film",
                "answer": "KANE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fresh, all over again",
                "answer": "ANEW",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The vast body of saltwater",
                "answer": "OCEAN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A nobleman in old Scotland",
                "answer": "THANE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Morning droplets on the grass",
                "answer": "DEW",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0226",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word that means 'however'",
                "answer": "BUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A creature that walks on two legs",
                "answer": "BIPED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Higher in position",
                "answer": "UPPER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "British word for the television set",
                "answer": "TELLY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "One who plays the flute",
                "answer": "PIPER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Average score on a golf hole",
                "answer": "PAR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Latin word seen in legal case names",
                "answer": "RES",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Fruit that keeps the doctor away",
                "answer": "APPLE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Spools for fishing line, or country dances",
                "answer": "REELS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Lacking any moisture",
                "answer": "DRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0227",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good ___",
                "answer": "USE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A workers' group that bargains together",
                "answer": "UNION",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Quick photo, or a finger sound",
                "answer": "SNAP",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Not at all hard to do",
                "answer": "EASY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Food said to fall from heaven in the Bible",
                "answer": "MANNA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Grain used in brewing and bread",
                "answer": "MALT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Soothing plant for sunburns",
                "answer": "ALOE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A false name a person goes by",
                "answer": "ALIAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A little bit silly or scatterbrained",
                "answer": "LOOPY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Number after nine",
                "answer": "TEN",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0228",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Having the skill or means to do something",
                "answer": "ABLE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Stage performers do this on the boards",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Brag or crow about an achievement",
                "answer": "BOAST",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Slender and graceful in build",
                "answer": "LITHE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Step inside the room",
                "answer": "ENTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A penny, nickel, or dime",
                "answer": "COIN",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Shabby and worn out",
                "answer": "TATTY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Orange-fleshed sweet potato",
                "answer": "YAM",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Nut whose butter is good for the skin",
                "answer": "SHEA",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A school semester or a set length of time",
                "answer": "TERM",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0229",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Number after two",
                "answer": "THREE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A test or hardship to get through",
                "answer": "TRIAL",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reddish dye used to color hair",
                "answer": "HENNA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Move a plant to a bigger container",
                "answer": "REPOT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Slip away from a pursuer",
                "answer": "ELUDE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Fruity-smelling chemical compound",
                "answer": "ESTER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Spools, or staggers about",
                "answer": "REELS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Type in data on a keyboard",
                "answer": "INPUT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Terminal of a battery, marked plus or minus",
                "answer": "ANODE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "At a future time than now",
                "answer": "LATER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0230",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The years from birth to old age",
                "answer": "LIFE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Speak with a soft S sound",
                "answer": "LISP",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Toward the middle, not the outside",
                "answer": "INNER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sudden burst of bright light",
                "answer": "FLARE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Strange and spooky",
                "answer": "EERIE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Narrow waterway leading into a bay",
                "answer": "INLET",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Let someone know the news",
                "answer": "TELL",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Trap set for a rabbit or bird",
                "answer": "SNARE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A great danger",
                "answer": "PERIL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Wind in a fishing line by hand",
                "answer": "REEL",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0231",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'A letter ___ an old friend'",
                "answer": "FROM",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The plant life of a region",
                "answer": "FLORA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flowing water, like the Mississippi",
                "answer": "RIVER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Vast body of saltwater, like the Pacific",
                "answer": "OCEAN",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Blend two metals together",
                "answer": "MELD",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Thin piece cut from a loaf",
                "answer": "SLICE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Wearing footwear, as a horse",
                "answer": "SHOD",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A run-down little shack",
                "answer": "HOVEL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Mountain nymph of Greek myth",
                "answer": "OREAD",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Mend a sock with needle and thread",
                "answer": "DARN",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0232",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'These flowers are ___ you'",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Grown pale or washed out over time",
                "answer": "FADED",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Woodwind with a reed, akin to a clarinet",
                "answer": "OBOE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Uncooked, as vegetables",
                "answer": "RAW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Little rum-soaked sponge cake",
                "answer": "BABA",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Greenish-yellow digestive fluid",
                "answer": "BILE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Woman whose husband has passed on",
                "answer": "WIDOW",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Thai dish of stir-fried noodles, ___ thai",
                "answer": "WAT",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "On the sheltered side of a ship",
                "answer": "ALEE",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Knight of the Round Table, Sir ___",
                "answer": "TED",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0233",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "No longer in the running",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Breakfast grain in porridge",
                "answer": "OATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single whole thing",
                "answer": "UNIT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Doughnut-shaped ring",
                "answer": "TORUS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Battery terminal marked with a plus or minus",
                "answer": "ANODE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Small dip or ding in a fender",
                "answer": "DENT",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Touchy and irritable",
                "answer": "EDGY",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Worn out after a long day",
                "answer": "TIRED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Smarting, as from a nettle",
                "answer": "STUNG",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Pen for keeping pigs",
                "answer": "STY",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0234",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Fresh out of the box",
                "answer": "NEW",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wearing no clothes",
                "answer": "NAKED",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Banish from one's homeland",
                "answer": "EXILE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Boy's name, short for William",
                "answer": "WILLY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "City cabs, for short",
                "answer": "TAXIS",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sound of mild scolding",
                "answer": "TSK",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Crafty and clever",
                "answer": "SLY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A talent or knack for something",
                "answer": "SKILL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Actress ___ McGillis of 'Top Gun'",
                "answer": "KELLY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Comic actress Susan ___ of '227'",
                "answer": "DEY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0235",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word meaning 'however'",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wraps tightly, as with twine",
                "answer": "BINDS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse or unfasten",
                "answer": "UNDO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Drop of water from a sad eye",
                "answer": "TEAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Geneticist who studies gradual variation, Arthur ___",
                "answer": "CLINE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Burn slightly, as a steak on the grill",
                "answer": "CHAR",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Old tales and traditions of a people",
                "answer": "LORE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Japanese carmaker known for the Civic",
                "answer": "HONDA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Burning passion or warmth of feeling",
                "answer": "ARDOR",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Latin word seen in legal case names",
                "answer": "RES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0236",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Tight little flower knobs about to open",
                "answer": "BUDS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Word meaning 'however'",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Clumsy and awkward, not handy",
                "answer": "UNAPT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "More dreadful than before",
                "answer": "DIRER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hard, gray rock used for buildings",
                "answer": "STONE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single whole, undivided",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A fortune-teller's deck of cards",
                "answer": "TAROT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Sound of gentle disapproval",
                "answer": "TSK",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Writing tools filled with ink",
                "answer": "PENS",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A long, rugged hike or journey",
                "answer": "TREK",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0237",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The greatest part",
                "answer": "MOST",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Crush boiled potatoes into a fluffy heap",
                "answer": "MASH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Many a time",
                "answer": "OFTEN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A shop where you buy things",
                "answer": "STORE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A singer's range, like soprano or bass",
                "answer": "TENOR",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Later than",
                "answer": "AFTER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Tear apart, as cloth",
                "answer": "REND",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A single rock, large or small",
                "answer": "STONE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Tall wading bird with long legs",
                "answer": "HERON",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bookish whiz fond of facts",
                "answer": "NERD",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0238",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The largest amount",
                "answer": "MOST",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Very small, with a prefix",
                "answer": "MICRO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Time and again",
                "answer": "OFTEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Hurl a stone with a leather strap",
                "answer": "SLING",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Look after, as a garden",
                "answer": "TEND",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A long firearm aimed at the shoulder",
                "answer": "RIFLE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "'I smell a ___'",
                "answer": "RATS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Protein found in muscle fibers",
                "answer": "ACTIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The latest fashion or craze",
                "answer": "TREND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A tune you hum along to",
                "answer": "SONG",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0239",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look and judge for yourself",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "'We ___ overcome'",
                "answer": "SHALL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "British nobleman ranking below a marquess",
                "answer": "EARL",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Where a road or a movie finishes",
                "answer": "END",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Comparison word: 'more ___'",
                "answer": "THAN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hammer, saw, or wrench",
                "answer": "TOOL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Plank of wood, or to climb onto a ship",
                "answer": "BOARD",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Undergarment for women",
                "answer": "BRA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Turn over and over, as a barrel",
                "answer": "ROLL",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Every bit of it",
                "answer": "ALL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0240",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "No longer in the game",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Belonging to us",
                "answer": "OURS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single whole thing",
                "answer": "UNIT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Having to do with the rise and fall of the sea",
                "answer": "TIDAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A joining together of two groups",
                "answer": "UNION",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Fairy-tale giant who says 'Fee-fi-fo-fum'",
                "answer": "OGRE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A bird's cozy home for its eggs",
                "answer": "NEST",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Raised line along the top of a roof",
                "answer": "RIDGE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Twinkling lights in the night sky",
                "answer": "STARS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Allow or permit",
                "answer": "LET",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0241",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This bouquet is ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One flat surface of a cut diamond",
                "answer": "FACET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The remaining one, of two choices",
                "answer": "OTHER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Tall and thin, like a marsh stalk",
                "answer": "REEDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Paired up, two by two",
                "answer": "MATED",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Day after Sunday, on a calendar (abbr.)",
                "answer": "MON",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Not the least bit damp",
                "answer": "DRY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Yellowish-brown earthy color",
                "answer": "OCHER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Poor and lacking life's basics",
                "answer": "NEEDY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Give it a go",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0242",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Three cheers ___ the winner!",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Deadly, as a serious error",
                "answer": "FATAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished, and done with",
                "answer": "OVER",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Take a breather",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Showing great courage",
                "answer": "BRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Poorly behaved youngster",
                "answer": "BRAT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Ready to eat, as fruit",
                "answer": "RIPE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Solemn ceremonies",
                "answer": "RITES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Separated by distance",
                "answer": "APART",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Phone number on TV, briefly",
                "answer": "TEL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0243",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Server's flat carrying dish",
                "answer": "TRAY",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"In ___ end\" (finally)",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Leader of a synagogue",
                "answer": "RABBI",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Steer clear of",
                "answer": "AVOID",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Matchmaker, in Yiddish tradition",
                "answer": "YENTE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Possess or own",
                "answer": "HAVE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Deep black, like a piano key",
                "answer": "EBONY",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Vote of agreement",
                "answer": "YEA",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Nip with the teeth",
                "answer": "BITE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bright thought",
                "answer": "IDEA",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0244",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Spot or location",
                "answer": "PLACE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Held-back animal at the bullring",
                "answer": "PRESA",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Sweetheart or admirer",
                "answer": "LOVER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Make changes to, as a law",
                "answer": "AMEND",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Old French troubadour song",
                "answer": "CANSO",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Walk through the doorway",
                "answer": "ENTER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Of the ancient empire ruled from Italy",
                "answer": "ROMAN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Special happening on the calendar",
                "answer": "EVENT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Feeling in your bones",
                "answer": "SENSE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Warm passion or zeal",
                "answer": "ARDOR",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0245",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"We ___ here all along\"",
                "answer": "WERE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Direction of the setting sun",
                "answer": "WEST",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put forth, as effort",
                "answer": "EXERT",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Box that brings music and news",
                "answer": "RADIO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Choose at the ballot box",
                "answer": "ELECT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Praise highly",
                "answer": "EXALT",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Oak or maple, for instance",
                "answer": "TREE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Passover supper",
                "answer": "SEDER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A very short moment",
                "answer": "TRICE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Carry, as a heavy bag",
                "answer": "TOTE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0246",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"May I ___ this dance?\"",
                "answer": "HAVE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Roaming crowd that swarms in",
                "answer": "HORDE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Gas in a glowing sign",
                "answer": "ARGON",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Leap high to clear a bar",
                "answer": "VAULT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "What spectacles help",
                "answer": "EYES",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Slippery sea creature, like an eel",
                "answer": "MORAY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Letters carried by the postman",
                "answer": "MAIL",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Have a heated disagreement",
                "answer": "ARGUE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Adored stars or heroes",
                "answer": "IDOLS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Gave up something for the season before Easter",
                "answer": "LENT",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0247",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "No longer in style",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Green spot in the desert",
                "answer": "OASIS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting atop, as a hat on a head",
                "answer": "UPON",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "2,000 pounds",
                "answer": "TON",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Clamp on a guitar neck that raises the pitch",
                "answer": "CAPO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Black fuel dug from a mine",
                "answer": "COAL",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Tiny particle in physics",
                "answer": "BOSON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Undergarment for support",
                "answer": "BRA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Wet weather from the clouds",
                "answer": "RAIN",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "More than one fellow named Al",
                "answer": "ALS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0249",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Reach ___ the stars\"",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Casual word for a guy",
                "answer": "FELLA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Tidy arrangement, or a command in court",
                "answer": "ORDER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Crumbling remains of an old castle",
                "answer": "RUINS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Liquid part of the blood",
                "answer": "SERUM",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Cry softly",
                "answer": "SOB",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Doctor, for short",
                "answer": "MED",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A golden tune from years past",
                "answer": "OLDIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Mix together smoothly",
                "answer": "BLEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "More than one of those creative degrees (abbr.)",
                "answer": "ARS",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0250",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Hope ___ the best\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Clenched hands, ready to box",
                "answer": "FISTS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single time",
                "answer": "ONCE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Take a breather",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Having to do with sheep",
                "answer": "OVINE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Lingering smell",
                "answer": "ODOR",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A bad habit or fault",
                "answer": "VICE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Round records, or modern silvery ones",
                "answer": "DISCS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Group of eight musicians",
                "answer": "OCTET",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Latin word for \"thing,\" in legal phrases",
                "answer": "RES",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0251",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Far off in the distance",
                "answer": "AWAY",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Deed or performance",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Forest full of trees",
                "answer": "WOODS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Chambers of the heart",
                "answer": "ATRIA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Birthday count",
                "answer": "YEARS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Small shelter for doves",
                "answer": "COTE",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sacred scroll in the synagogue",
                "answer": "TORAH",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Chuckle written as a syllable",
                "answer": "HEH",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Grim or desperate",
                "answer": "DIRE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Band of cloth worn over the shoulder",
                "answer": "SASH",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0252",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Texas or Maine, for one",
                "answer": "STATE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wise spiritual teacher from the East",
                "answer": "SWAMI",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Sharp claw of an eagle",
                "answer": "TALON",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Spy working secretly",
                "answer": "AGENT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Rich layered dessert",
                "answer": "TORTE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Type a key to send the form",
                "answer": "ENTER",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Covered cart pulled by horses",
                "answer": "WAGON",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "On the lookout for danger",
                "answer": "ALERT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fast card game with a Spanish name",
                "answer": "MONTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bury, as the departed",
                "answer": "INTER",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0253",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Grab hold of",
                "answer": "TAKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Greenish-blue shade of duck feathers",
                "answer": "TEAL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Spoken so all can hear",
                "answer": "ALOUD",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The idea that good and bad deeds come back around",
                "answer": "KARMA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Type a key to submit",
                "answer": "ENTER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Large African antelope",
                "answer": "ELAND",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Damp and chilly, like a cellar",
                "answer": "DANK",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Main artery from the heart",
                "answer": "AORTA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Unit of brightness for a bulb",
                "answer": "LUMEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Without any light",
                "answer": "DARK",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0254",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Better late ___ never\"",
                "answer": "THAN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sparkling crown for a queen",
                "answer": "TIARA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Great respect and esteem",
                "answer": "HONOR",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "An \"I wasn't there\" excuse",
                "answer": "ALIBI",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Pleasant and agreeable",
                "answer": "NICE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Garlic mayonnaise spread",
                "answer": "AIOLI",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Electric current measures, for short",
                "answer": "AMPS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Wildly frantic",
                "answer": "MANIC",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Look into closely, as a question",
                "answer": "PROBE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Wrapped garment worn in India",
                "answer": "SARI",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0255",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not at home, but ___ and about",
                "answer": "OUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sixteenth of a pound",
                "answer": "OUNCE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse what you just did",
                "answer": "UNDO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Hot drink steeped in a cup",
                "answer": "TEA",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Melody you can hum",
                "answer": "TUNE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Starchy root used in Hawaiian poi",
                "answer": "TARO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Black-and-white bear that loves bamboo",
                "answer": "PANDA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A cat's soft foot",
                "answer": "PAW",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Played with the bow, in a music score",
                "answer": "ARCO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Cry of sorrow, as in \"___ is me\"",
                "answer": "WOE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0256",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Slow ___ steady wins the race\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Flying mammals of the cave",
                "answer": "BATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single whole, one of a kind",
                "answer": "UNIT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Lab measure of a solution's strength",
                "answer": "TITER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Licorice-flavored seed used in baking",
                "answer": "ANISE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Nut butter from an African tree, used in lotions",
                "answer": "SHEA",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Slithery fish, often smoked",
                "answer": "EELS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Old-fashioned gift of a tenth to the church",
                "answer": "TITHE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Strong metal in girders",
                "answer": "STEEL",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Plural ending on some Latin words, like \"auras\"",
                "answer": "RAS",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0257",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Slow ___ steady\" (one way to win)",
                "answer": "BUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Brush a roast with its own juices",
                "answer": "BASTE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "More complete, to the fullest degree",
                "answer": "UTTER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Belonging to them",
                "answer": "THEIR",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Spinning wheel that shapes a clay pot",
                "answer": "LATHE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Vegas, in Spanish-flavored names",
                "answer": "LAS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sea eagle of crossword fame",
                "answer": "ERN",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Purple or white garden flower",
                "answer": "ASTER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Tall beer mug with a handle",
                "answer": "STEIN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Make a mistake",
                "answer": "ERR",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0258",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Stage performance, or what one does on it",
                "answer": "ACT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Growing older year by year",
                "answer": "AGING",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Look after with tenderness",
                "answer": "CARE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Drop fallen from a crying eye",
                "answer": "TEAR",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Slimy green growth on a pond",
                "answer": "ALGAE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Wildly out of control, as in running ___",
                "answer": "AMOK",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Actor Rob of TV's \"The West Wing\"",
                "answer": "LOWE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Wavy, watery pattern on silk fabric",
                "answer": "MOIRA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Person who holds the deed to a house",
                "answer": "OWNER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Small barrel for beer",
                "answer": "KEG",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0259",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Grain in your morning porridge",
                "answer": "OATS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Way to leave the room",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Soul or inner spirit, in psychology",
                "answer": "ANIMA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Shy and easily frightened",
                "answer": "TIMID",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Office worker who takes dictation, for short",
                "answer": "STENO",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single whole thing",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Set the clock for, as an exact moment",
                "answer": "TIMED",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Show disrespect to, in slang",
                "answer": "DIS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Smallest size, or a short skirt",
                "answer": "MINI",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bits of fuss and bother",
                "answer": "ADOS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0260",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Along ___ (together)",
                "answer": "WITH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Determination to succeed",
                "answer": "WILL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Everyday saying with a hidden meaning",
                "answer": "IDIOM",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Small colorful fish in a home aquarium",
                "answer": "TETRA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sturdy, like a tough plant",
                "answer": "HARDY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Just perfect, beyond compare",
                "answer": "IDEAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Smaller in amount",
                "answer": "LESS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Metric measure of soda, spelled the British way",
                "answer": "LITRE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Nobles ranking above knights",
                "answer": "LORDS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Famous Willie of baseball, or month-name plurals",
                "answer": "MAYS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0261",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The greatest amount",
                "answer": "MOST",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Sweet tropical fruit with a big pit",
                "answer": "MANGO",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Command, as from a captain",
                "answer": "ORDER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Pleasant smell",
                "answer": "SCENT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Words on a page",
                "answer": "TEXT",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A silly, over-the-top comedy",
                "answer": "FARCE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Official order or decree",
                "answer": "FIAT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Alphabetical list at the back of a book",
                "answer": "INDEX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Person acting on another's behalf",
                "answer": "AGENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A civil wrong, in legal terms",
                "answer": "TORT",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0262",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch sight of",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Barking creatures that bask on rocks",
                "answer": "SEALS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "British noble ranking below a marquess",
                "answer": "EARL",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The very last bit",
                "answer": "END",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Unkind or cruel",
                "answer": "MEAN",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A blue or cheerful frame of mind",
                "answer": "MOOD",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Plank of wood, or a group of directors",
                "answer": "BOARD",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Support garment worn up top",
                "answer": "BRA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Turn over and over, like a barrel downhill",
                "answer": "ROLL",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Newspaper notices selling things",
                "answer": "ADS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0263",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take the dog ___ for a walk",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Milky gemstone with rainbow flashes",
                "answer": "OPAL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Strong desire to do something",
                "answer": "URGE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Holy book of the Jewish faith",
                "answer": "TORAH",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Roam about hunting, like a cat at night",
                "answer": "PROWL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "\"As you ___\" (carry on)",
                "answer": "WERE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Glass piece in eyeglasses or a camera",
                "answer": "LENS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Say yes and go along with",
                "answer": "AGREE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Pick up new knowledge",
                "answer": "LEARN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Casual word for several men",
                "answer": "HES",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0264",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Nothing ___ the best\"",
                "answer": "BUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Cardboard cartons for moving",
                "answer": "BOXES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Right up to the moment of",
                "answer": "UNTIL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Linger or wait around",
                "answer": "TARRY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Underwater sound-detecting device",
                "answer": "SONAR",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Stitch with needle and thread",
                "answer": "SEW",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Slang for very cool, or a unit of radiation",
                "answer": "RAD",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A little something more, like cheese on top",
                "answer": "EXTRA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Strange and spooky",
                "answer": "WEIRD",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Crafty and shrewd",
                "answer": "SLY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0265",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Just ___ instance...\"",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Disastrous, as a flaw with no remedy",
                "answer": "FATAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Done and complete",
                "answer": "OVER",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Relax and take it easy",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Serious and solemn",
                "answer": "GRAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Metric unit of weight",
                "answer": "GRAM",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "At its peak, as a juicy peach",
                "answer": "RIPE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Sacred religious ceremonies",
                "answer": "RITES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Split up, no longer together",
                "answer": "APART",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Blanc who voiced cartoon characters",
                "answer": "MEL",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0266",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Flower sprouts about to bloom",
                "answer": "BUDS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"Slow ___ steady wins the race\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pieces in a measuring system",
                "answer": "UNITS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A single numeral, like 7",
                "answer": "DIGIT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Solid lump in the garden, or in a peach",
                "answer": "STONE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single whole, of measurement",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Cross between a tiger and a lion",
                "answer": "TIGON",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Brand-___ (just bought)",
                "answer": "NEW",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "One prong of a fork",
                "answer": "TINE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Simmered dish of meat and vegetables",
                "answer": "STEW",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0267",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"___ way did he go?\"",
                "answer": "WHICH",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Old American political party of Lincoln's early days",
                "answer": "WHIGS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Many-headed monster of Greek myth",
                "answer": "HYDRA",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Just perfect, the very best",
                "answer": "IDEAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Long for deeply, as affection",
                "answer": "CRAVE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rubber tubes for watering the garden",
                "answer": "HOSES",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Like power from a dam, for short",
                "answer": "HYDRO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bright thoughts and notions",
                "answer": "IDEAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Serious and dignified",
                "answer": "GRAVE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bargains at the shop",
                "answer": "SALES",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0268",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Wish for or desire",
                "answer": "WANT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bend or twist out of shape",
                "answer": "WARP",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "One more time",
                "answer": "AGAIN",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Grand and dignified, like a lord",
                "answer": "NOBLE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Gives it a go, makes attempts",
                "answer": "TRIES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Open marketplace of ancient Greece",
                "answer": "AGORA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Sums up, as in arithmetic",
                "answer": "ADDS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Foaming at the mouth, as a sick animal",
                "answer": "RABID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Stacked up in a heap",
                "answer": "PILED",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "A narrow point of land, in Scotland",
                "answer": "NESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0269",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Feel the urge for",
                "answer": "WANT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Overgrown with unwanted plants",
                "answer": "WEEDY",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Yet another time",
                "answer": "AGAIN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Caring helper at a hospital",
                "answer": "NURSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Quiz or examination",
                "answer": "TEST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Smooth shift from one song to the next",
                "answer": "SEGUE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Fired bullet, or a small drink",
                "answer": "SHOT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Listens to",
                "answer": "HEARS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Writer of poems",
                "answer": "ODIST",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "River through Newcastle, England",
                "answer": "TYNE",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0270",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Have a look at",
                "answer": "SEE",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wander off and get lost",
                "answer": "STRAY",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Simple and not hard at all",
                "answer": "EASY",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Male deer with antlers",
                "answer": "STAG",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Only one, all by itself",
                "answer": "SOLE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "The trunk of the body",
                "answer": "TORSO",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Sound of mild disapproval",
                "answer": "TSK",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Strike down, in old tales of battle",
                "answer": "SLAY",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Little metal piece that opens a lock",
                "answer": "KEY",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0271",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"All ___ done\" connector",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Worm on a fishhook, for instance",
                "answer": "BAIT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse, as a stitch or a buttoned coat",
                "answer": "UNDO",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Layers of a wedding cake",
                "answer": "TIERS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Jung's term for the inner self",
                "answer": "ANIMA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What you do to potatoes for a creamy side dish",
                "answer": "MASH",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Soothing plant for sunburns",
                "answer": "ALOE",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Just perfect",
                "answer": "IDEAL",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The trunk of the body",
                "answer": "TORSO",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Pronoun for a woman",
                "answer": "SHE",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0272",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not correct",
                "answer": "WRONG",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "French farewell",
                "answer": "ADIEU",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Word said with a sincere apology",
                "answer": "SORRY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Burning passion or enthusiasm",
                "answer": "ARDOR",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "French word for a friend",
                "answer": "AMI",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cheese-loving rodent",
                "answer": "RAT",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Girl's name, as in actress Kelly's daughter",
                "answer": "MOIRA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Completely still and unmoving",
                "answer": "INERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fellow or chap",
                "answer": "GUY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0273",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Last ___ not least\"",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Narrow-minded, prejudiced person",
                "answer": "BIGOT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single whole, like one item in a set",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Quality of a singing voice",
                "answer": "TONE",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Type of acid that builds proteins",
                "answer": "AMINO",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Help or encourage wrongdoing",
                "answer": "ABET",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Short written office note",
                "answer": "MEMO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Start, or commence",
                "answer": "BEGIN",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Show feelings dramatically on stage",
                "answer": "EMOTE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Little youngster",
                "answer": "TOT",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0274",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Olive and canola, for cooking",
                "answer": "OILS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not at home; away",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Silly and pointless",
                "answer": "INANE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Fat or oil, in chemistry",
                "answer": "LIPID",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bee's painful jab",
                "answer": "STING",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A single item, or a soldier's group",
                "answer": "UNIT",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Hoofed animal with a long snout, related to horses",
                "answer": "TAPIR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Scottish word for a wild dance, the Highland ___",
                "answer": "REE",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Number after eight",
                "answer": "NINE",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The very rim or border of something",
                "answer": "EDGE",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0275",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Set down or position something carefully",
                "answer": "PLACE",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Backyard nuisances, like aphids and beetles",
                "answer": "PESTS",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Roofed porch in Hawaii",
                "answer": "LANAI",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Tiniest building blocks of matter",
                "answer": "ATOMS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Roman goddess of the harvest",
                "answer": "CERES",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A way in, or a line in a logbook",
                "answer": "ENTRY",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Consumed at the dinner table",
                "answer": "EATEN",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Pig's noisy grunt",
                "answer": "SNORT",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "One who trains wild animals",
                "answer": "TAMER",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Old-fashioned word for a timid person",
                "answer": "SISSY",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0276",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Be fond of; enjoy",
                "answer": "LIKE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "One who does not tell the truth",
                "answer": "LIAR",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Perfect example of its kind",
                "answer": "IDEAL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "\"Lord, have mercy\" prayer in church music",
                "answer": "KYRIE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Leave out a syllable when speaking",
                "answer": "ELIDE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "A peaceful, charming country scene",
                "answer": "IDYLL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Smaller in amount",
                "answer": "LESS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "An eagle's high mountain nest",
                "answer": "AERIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sudden surprise attacks",
                "answer": "RAIDS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Sediment at the bottom of a wine barrel",
                "answer": "LEES",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0277",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Craft or build by hand",
                "answer": "MAKE",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A confused, rough-and-tumble brawl",
                "answer": "MELEE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Solo songs in an opera",
                "answer": "ARIAS",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Brand known for macaroni and cheese",
                "answer": "KRAFT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Not hard to do",
                "answer": "EASY",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Latin for the earth, as in ___ firma",
                "answer": "TERRA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Reaching a great height",
                "answer": "TALL",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A false name someone goes by",
                "answer": "ALIAS",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Full of greenery, like a summer tree",
                "answer": "LEAFY",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "For fear that; \"___ we forget\"",
                "answer": "LEST",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0278",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However; on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Wooden rail dancers hold at the ballet studio",
                "answer": "BARRE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "One of something; a single piece",
                "answer": "UNIT",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Nickname for a man named Edward",
                "answer": "TED",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Of sound mind; sensible",
                "answer": "SANE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Jazzy nonsense-syllable singing",
                "answer": "SCAT",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Bitter and harsh, like a sharp smell",
                "answer": "ACRID",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Doctors' group, for short",
                "answer": "AMA",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A place to buy goods; a marketplace",
                "answer": "MART",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0279",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not safe, in baseball",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___, I did it again\" exclamation of a small mistake",
                "answer": "OOPS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Resting on top of",
                "answer": "UPON",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Cone-shaped Native American dwelling",
                "answer": "TEPEE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A grand musical drama with singing",
                "answer": "OPERA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Five hundred sheets of paper",
                "answer": "REAM",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Poses questions",
                "answer": "ASKS",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Leaders of the Catholic Church",
                "answer": "POPES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Move quietly so as not to be noticed",
                "answer": "SNEAK",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Letters M, spelled out in plural",
                "answer": "EMS",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0280",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word joining two opposing ideas",
                "answer": "BUT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Surrounded and troubled on all sides",
                "answer": "BESET",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Higher in position; the top floor",
                "answer": "UPPER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Very tiny indeed",
                "answer": "TEENY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cone-shaped tent of the Plains tribes",
                "answer": "TEPEE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Lacy handmade trim",
                "answer": "TAT",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Filler sounds in hesitant speech",
                "answer": "ERS",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Old coin of Yemen",
                "answer": "ASPER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Youngsters aged thirteen to nineteen",
                "answer": "TEENS",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Give it a go; make an attempt",
                "answer": "TRY",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0281",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Meant ___ you",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Slaps of the hand, in a card game with that name",
                "answer": "FIVES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Not closed; the shop is now ___",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Tall grass by a pond, or part of a clarinet",
                "answer": "REED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Complain or grumble",
                "answer": "GRIPE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Gloomy and downhearted",
                "answer": "GLUM",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Taken-back car, for short",
                "answer": "REPO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Riverside bank that holds back floods",
                "answer": "LEVEE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Tip over; turn on its end",
                "answer": "UPEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Months, abbreviated",
                "answer": "MOS",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0282",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Hard fat used in bird feeders and old recipes",
                "answer": "SUET",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Look with the eyes",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Up to the time that",
                "answer": "UNTIL",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Dodge or escape, as a question",
                "answer": "EVADE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Spelling slips when at the keyboard",
                "answer": "TYPOS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Wanting what someone else has",
                "answer": "ENVY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A day's march, in old military terms",
                "answer": "ETAPE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Plural of the letter L",
                "answer": "ELS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Someone greatly admired or worshipped",
                "answer": "IDOL",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Fewer in amount",
                "answer": "LESS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0283",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Where there's a ___, there's a way\"",
                "answer": "WILL",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Showing good judgment and sense",
                "answer": "WISE",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Bright thoughts and clever notions",
                "answer": "IDEAS",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Slow tempo marking in music",
                "answer": "LENTO",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Focused beam of light used in surgery",
                "answer": "LASER",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Just perfect; couldn't be better",
                "answer": "IDEAL",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Season of fasting before Easter",
                "answer": "LENT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Sound judgment, or one of the body's five",
                "answer": "SENSE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Finished off, as a whole meal",
                "answer": "EATEN",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Arrange by type or kind",
                "answer": "SORT",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0284",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Back ___ and now\"",
                "answer": "THEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A central idea or subject of a talk",
                "answer": "THEME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A safe, peaceful refuge",
                "answer": "HAVEN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A happening or special occasion",
                "answer": "EVENT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Require; can't do without",
                "answer": "NEED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Use a razor in the morning",
                "answer": "SHAVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cut down a great many; mowed",
                "answer": "SLEW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Riverbank built up to hold back water",
                "answer": "LEVEE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Correct the errors in a text",
                "answer": "EMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Departed; up and ___",
                "answer": "WENT",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0285",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "The person being spoken to",
                "answer": "YOU",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not old; in the early years of life",
                "answer": "YOUNG",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single time",
                "answer": "ONCE",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Put to work, as a tool",
                "answer": "USE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Great big amounts",
                "answer": "TONS",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Crunchy Mexican shell filled with meat",
                "answer": "TACO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Topping for spaghetti",
                "answer": "SAUCE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Feeling blue and unhappy",
                "answer": "SAD",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Blemish on a teenager's face",
                "answer": "ACNE",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Loyal pet that fetches the newspaper",
                "answer": "DOG",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0286",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This gift is ___ you\"",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Belonging to us; not theirs",
                "answer": "OURS",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A single whole; one piece in a set",
                "answer": "UNIT",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Having to do with the rise and fall of the sea",
                "answer": "TIDAL",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Joining together, like a labor group",
                "answer": "UNION",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Fairy-tale monster, big and grumpy",
                "answer": "OGRE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Require; can't do without",
                "answer": "NEED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A long, narrow hilltop",
                "answer": "RIDGE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Look at fixedly with wide eyes",
                "answer": "STARE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Guided by the hand; past tense of lead",
                "answer": "LED",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0287",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In favor of, not against",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A barrier of pickets around a yard",
                "answer": "FENCE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Tidy arrangement, or a command in a restaurant",
                "answer": "ORDER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Crumbling remains of an old castle",
                "answer": "RUINS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Medical liquid drawn from blood, or a skin lotion",
                "answer": "SERUM",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Family member, for short, who shares your parents",
                "answer": "SIS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Was introduced to; \"We ___ years ago\"",
                "answer": "MET",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Independent, as a small film studio",
                "answer": "INDIE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A pleasant smell carried on the air",
                "answer": "SCENT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Letter R, written out in plural",
                "answer": "ERS",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0288",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of; meant to benefit",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Roughage that aids digestion",
                "answer": "FIBER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Finished and done; the game is ___",
                "answer": "OVER",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A good night's sleep gives you this",
                "answer": "REST",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Steer a car down the road",
                "answer": "DRIVE",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Let fall to the ground",
                "answer": "DROP",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Wander about without a fixed path",
                "answer": "ROVE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Loose garments worn after a bath",
                "answer": "ROBES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Open and obvious, not hidden",
                "answer": "OVERT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0289",
        "size": "mini",
        "difficulty": "easy",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Already owned by another, like a pre-owned car",
                "answer": "USED",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Make good of; put to work",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Bowl of mixed greens",
                "answer": "SALAD",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Woman's name, or a heather shrub",
                "answer": "ERICA",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A short, simple little song",
                "answer": "DITTY",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Graceful wrapped garment worn in India",
                "answer": "SARI",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "The very best; a select few",
                "answer": "ELITE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Letter S, spelled out",
                "answer": "ESS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Things done; deeds, or a play's divisions",
                "answer": "ACTS",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Twenty-four-hour periods",
                "answer": "DAYS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0290",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Coming before all the others",
                "answer": "FIRST",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A big holiday meal",
                "answer": "FEAST",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Bring upon oneself, as a debt",
                "answer": "INCUR",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Knot the laces again",
                "answer": "RETIE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Struck hard, in old-fashioned tales",
                "answer": "SMOTE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rubber rings on a car's wheels, British spelling",
                "answer": "TYRES",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Opponent or foe",
                "answer": "ENEMY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Performer in a play or movie",
                "answer": "ACTOR",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A matched set of hotel rooms",
                "answer": "SUITE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Oaks, pines, and maples",
                "answer": "TREES",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0291",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A certain unspecified amount",
                "answer": "SOME",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A dishonest trick or swindle",
                "answer": "SCAM",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A neat sequence, or a command for food",
                "answer": "ORDER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Large antlered animal of the north woods",
                "answer": "MOOSE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "European money since 2002",
                "answer": "EUROS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Childhood illness with a barking cough",
                "answer": "CROUP",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Held in, like up feelings",
                "answer": "PENT",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Cherish and love deeply",
                "answer": "ADORE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A tiny atomic particle",
                "answer": "MESON",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Take a break and relax",
                "answer": "REST",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0292",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Those people over there",
                "answer": "THEY",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The main subject of a book or party",
                "answer": "THEME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Itchy welts from a bee sting",
                "answer": "HIVES",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A planned happening, like a concert",
                "answer": "EVENT",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A fenced patch of grass behind the house",
                "answer": "YARD",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Hindu god of destruction and renewal",
                "answer": "SHIVA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cut down a great many; mowed",
                "answer": "SLEW",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A bar used to pry or lift",
                "answer": "LEVER",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Correct mistakes in a manuscript",
                "answer": "EMEND",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Direction where the sun sets",
                "answer": "WEST",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0293",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word joining two opposing ideas",
                "answer": "BUT",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A cluster, as of grapes or flowers",
                "answer": "BUNCH",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Reverse what was just done",
                "answer": "UNDO",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Soothing afternoon cup, often with lemon",
                "answer": "TEA",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A pleasant melody to hum",
                "answer": "TUNE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Ripped, like a sheet of paper",
                "answer": "TORE",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Japanese carmaker known for the Civic",
                "answer": "HONDA",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A short laugh of triumph",
                "answer": "HAH",
                "row": 2,
                "col": 0,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Played with the bow, in music",
                "answer": "ARCO",
                "row": 3,
                "col": 0,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Quiet chuckle sound",
                "answer": "HEH",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0294",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "X",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This bouquet is ___ you, dear\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Utensil with prongs, beside the spoon",
                "answer": "FORK",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Unlocked, like a door left ajar",
                "answer": "OPEN",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Send a payment by mail",
                "answer": "REMIT",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A grand sung drama at the theater",
                "answer": "OPERA",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Widespread, as a common rumor",
                "answer": "RIFE",
                "row": 1,
                "col": 3,
                "length": 4
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Leaping jump in figure skating",
                "answer": "AXEL",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A new version of a song",
                "answer": "REMIX",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sharp blade for slicing bread",
                "answer": "KNIFE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Number to call, on a business card (abbr.)",
                "answer": "TEL",
                "row": 4,
                "col": 2,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0295",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Intended to benefit; on behalf of",
                "answer": "FOR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Border holding a picture on the wall",
                "answer": "FRAME",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Tidy lineup, or a restaurant request",
                "answer": "ORDER",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Lists of names, called at the start of class",
                "answer": "ROLLS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Pointed shaft shot from a bow",
                "answer": "ARROW",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sportscaster Michaels and others",
                "answer": "ALS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Damp, like grass with morning dew",
                "answer": "WET",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Long-handled spoon for serving soup",
                "answer": "LADLE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Small silvery fish, often fried whole",
                "answer": "SMELT",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Letter R, written out in plural",
                "answer": "ERS",
                "row": 4,
                "col": 1,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0296",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In favor of, not against",
                "answer": "FOR",
                "row": 0,
                "col": 2,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Unit of electrical capacitance",
                "answer": "FARAD",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Ready for business, with doors unlocked",
                "answer": "OPEN",
                "row": 0,
                "col": 3,
                "length": 4
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A chance of danger or loss",
                "answer": "RISK",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Striped African relative of the giraffe",
                "answer": "OKAPI",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Switches the lights ___ before bed",
                "answer": "OFFS",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "One thousand grams",
                "answer": "KILO",
                "row": 1,
                "col": 1,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Burning blazes in a hearth",
                "answer": "FIRES",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Side of the body between ribs and hip",
                "answer": "FLANK",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Square of grass cut for a new lawn",
                "answer": "SOD",
                "row": 4,
                "col": 0,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0297",
        "size": "mini",
        "difficulty": "medium",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Composer of \"Air on the G String\"",
                "answer": "BACH",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"All ___ one, and one for all\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Say yes; come to the same opinion",
                "answer": "AGREE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Funny fellow with a red nose at the circus",
                "answer": "CLOWN",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Built up with great excitement",
                "answer": "HYPED",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Not pretty to look at",
                "answer": "UGLY",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A familiar theme or figure of speech",
                "answer": "TROPE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "down",
                "clue": "Letter S, spelled out",
                "answer": "ESS",
                "row": 2,
                "col": 4,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Female sheep",
                "answer": "EWES",
                "row": 3,
                "col": 1,
                "length": 4
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Finishes; brings to a close",
                "answer": "ENDS",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0298",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Where a judge hears a case",
                "answer": "COURT",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Hold tightly, as in a handshake",
                "answer": "CLASP",
                "row": 0,
                "col": 0,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Worker who greases machine parts",
                "answer": "OILER",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Join together as one",
                "answer": "UNITE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Picture puzzle that spells a word or phrase",
                "answer": "REBUS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Stumbles, or short journeys",
                "answer": "TRIPS",
                "row": 0,
                "col": 4,
                "length": 5
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "A great ocean ship for passengers",
                "answer": "LINER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Proof of being elsewhere when something happened",
                "answer": "ALIBI",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The way things are arranged; an arrangement",
                "answer": "SETUP",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Newspapers and reporters, collectively",
                "answer": "PRESS",
                "row": 4,
                "col": 0,
                "length": 5
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0299",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"___ in the world is going on?\"",
                "answer": "WHAT",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Material from a tree, used to build a fire",
                "answer": "WOOD",
                "row": 0,
                "col": 0,
                "length": 4
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Bees' honey-making homes",
                "answer": "HIVES",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Bring into a straight row, old spelling",
                "answer": "ALINE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Nervous and on edge; uptight",
                "answer": "TENSE",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Ship that carries petroleum, or a kind of well lubricator",
                "answer": "OILER",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Marsh plant, or part of a woodwind instrument",
                "answer": "REED",
                "row": 1,
                "col": 4,
                "length": 4
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Having to do with sheep",
                "answer": "OVINE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Thick and crowded together",
                "answer": "DENSE",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "What you plant to grow a flower",
                "answer": "SEED",
                "row": 4,
                "col": 1,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "mini-gen-0300",
        "size": "mini",
        "difficulty": "hard",
        "rows": 5,
        "cols": 5,
        "grid": [
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 3
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"My, that was a ___ meal!\"",
                "answer": "GOOD",
                "row": 0,
                "col": 1,
                "length": 4
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Magical spirit from a lamp",
                "answer": "GENIE",
                "row": 0,
                "col": 1,
                "length": 5
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Small green or black fruit on a pizza",
                "answer": "OLIVE",
                "row": 0,
                "col": 2,
                "length": 5
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Green refuge in the desert with water and palms",
                "answer": "OASIS",
                "row": 0,
                "col": 3,
                "length": 5
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Colored with a stain, as Easter eggs",
                "answer": "DYED",
                "row": 0,
                "col": 4,
                "length": 4
            },
            {
                "number": 5,
                "direction": "across",
                "clue": "Secure a climbing rope",
                "answer": "BELAY",
                "row": 1,
                "col": 0,
                "length": 5
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Round toy you bounce or throw",
                "answer": "BALL",
                "row": 1,
                "col": 0,
                "length": 4
            },
            {
                "number": 6,
                "direction": "across",
                "clue": "Licorice-flavored seed used in baking",
                "answer": "ANISE",
                "row": 2,
                "col": 0,
                "length": 5
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Furious; bruised to a purplish color",
                "answer": "LIVID",
                "row": 3,
                "col": 0,
                "length": 5
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Sediment settling in a wine cask",
                "answer": "LEES",
                "row": 4,
                "col": 0,
                "length": 4
            }
        ],
        "attribution": "Generated by tools/crossword-build (clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    }
];
//# sourceMappingURL=generated.js.map